import regeneratorRuntime from "regenerator-runtime";
import { ethers, BigNumber, Wallet } from 'ethers';
import { Erc20Abi, DelysiumAbi, DelysiumAssetsAbi, DelysiumStoreAbi, TeleportAbi, Erc721Abi, DMAAbi, TokenWithdrawalAbi } from '@delysium/abi';
import { keccak256, toUtf8Bytes } from 'ethers/lib/utils';
import axios from 'axios';
import uuidToHex from 'uuid-to-hex';
import { Client, authQuery, Auth } from '@delysium/sso';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ContractSDK = /*#__PURE__*/function () {
  function ContractSDK(signer, contractAddress, abi) {
    _classCallCheck(this, ContractSDK);

    _defineProperty(this, "confirmBlocks", 1);

    this.contractAddress = contractAddress;
    this.signer = signer;
    this.abi = abi;
    this.contract = new ethers.Contract(contractAddress, abi, signer);
  }

  _createClass(ContractSDK, [{
    key: "connectSigner",
    value: function connectSigner(signer) {
      this.signer = signer;
      this.contract = new ethers.Contract(this.contractAddress, this.abi, signer);
    }
  }]);

  return ContractSDK;
}();

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var ErrorType;

(function (ErrorType) {
  ErrorType["PreOrder_NoSupply"] = "PreOrder_NoSupply";
  ErrorType["Token_NoSupply"] = "Token_NoSupply";
  ErrorType["Token_InsufficientBalance"] = "Token_InsufficientBalance";
  ErrorType["Token_NotOwned"] = "Token_NotOwned";
  ErrorType["Wallet_InsufficientBalance"] = "Wallet_InsufficientBalance";
  ErrorType["Wallet_InsufficientAllowance"] = "Wallet_InsufficientAllowance";
  ErrorType["Format_InvalidUInt"] = "Format_InvalidUInt";
  ErrorType["Format_InvalidParameter"] = "Format_InvalidParameter";
})(ErrorType || (ErrorType = {}));

var Erc20SDK = /*#__PURE__*/function (_ContractSDK) {
  _inherits(Erc20SDK, _ContractSDK);

  var _super = _createSuper(Erc20SDK);

  function Erc20SDK(signer, contractAddress) {
    _classCallCheck(this, Erc20SDK);

    return _super.call(this, signer, contractAddress, Erc20Abi);
  }

  _createClass(Erc20SDK, [{
    key: "getAllowance",
    value: function () {
      var _getAllowance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(owner, spender) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.contract.allowance(owner, spender));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllowance(_x, _x2) {
        return _getAllowance.apply(this, arguments);
      }

      return getAllowance;
    }()
  }, {
    key: "adjustAllowance",
    value: function () {
      var _adjustAllowance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(spender, amount) {
        var caller, allowance;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context2.sent;
                _context2.next = 5;
                return this.getAllowance(caller, spender);

              case 5:
                allowance = _context2.sent;

                if (!allowance.lt(amount)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 9;
                return this.approveMaxAllowance(spender);

              case 9:
                return _context2.abrupt("return", _context2.sent);

              case 10:
                return _context2.abrupt("return", true);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function adjustAllowance(_x3, _x4) {
        return _adjustAllowance.apply(this, arguments);
      }

      return adjustAllowance;
    }()
  }, {
    key: "approve",
    value: function () {
      var _approve = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(spender, amount) {
        var tx;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.contract.approve(spender, amount);

              case 2:
                tx = _context3.sent;
                _context3.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context3.abrupt("return", _context3.sent);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function approve(_x5, _x6) {
        return _approve.apply(this, arguments);
      }

      return approve;
    }()
  }, {
    key: "approveMaxAllowance",
    value: function () {
      var _approveMaxAllowance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(spender) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.approve(spender, Erc20SDK.MAX_ALLOWANCE);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function approveMaxAllowance(_x7) {
        return _approveMaxAllowance.apply(this, arguments);
      }

      return approveMaxAllowance;
    }()
    /** Balance **/

  }, {
    key: "balanceOf",
    value: function () {
      var _balanceOf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(address) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.contract.balanceOf(address));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function balanceOf(_x8) {
        return _balanceOf.apply(this, arguments);
      }

      return balanceOf;
    }()
  }, {
    key: "hasBalanceFor",
    value: function () {
      var _hasBalanceFor = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(address, value) {
        var balance;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.balanceOf(address);

              case 2:
                balance = _context6.sent;
                return _context6.abrupt("return", balance.gte(value));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function hasBalanceFor(_x9, _x10) {
        return _hasBalanceFor.apply(this, arguments);
      }

      return hasBalanceFor;
    }()
    /** Transfer **/

  }, {
    key: "transfer",
    value: function () {
      var _transfer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(to, amount) {
        var caller, balance, tx;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context7.sent;
                _context7.next = 5;
                return this.contract.balanceOf(caller);

              case 5:
                balance = _context7.sent;

                if (!balance.lt(amount)) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return", Promise.reject(ErrorType.Token_InsufficientBalance));

              case 8:
                _context7.next = 10;
                return this.contract.transfer(to, amount);

              case 10:
                tx = _context7.sent;
                _context7.next = 13;
                return tx.wait(this.confirmBlocks);

              case 13:
                return _context7.abrupt("return", _context7.sent);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function transfer(_x11, _x12) {
        return _transfer.apply(this, arguments);
      }

      return transfer;
    }()
  }, {
    key: "transferFrom",
    value: function () {
      var _transferFrom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(from, to, amount) {
        var caller, balance, tx;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context8.sent;
                _context8.next = 5;
                return this.contract.balanceOf(caller);

              case 5:
                balance = _context8.sent;

                if (!balance.lt(amount)) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("return", Promise.reject(ErrorType.Token_InsufficientBalance));

              case 8:
                _context8.next = 10;
                return this.contract.transferFrom(from, to, amount);

              case 10:
                tx = _context8.sent;
                _context8.next = 13;
                return tx.wait(this.confirmBlocks);

              case 13:
                return _context8.abrupt("return", _context8.sent);

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function transferFrom(_x13, _x14, _x15) {
        return _transferFrom.apply(this, arguments);
      }

      return transferFrom;
    }()
  }]);

  return Erc20SDK;
}(ContractSDK);

_defineProperty(Erc20SDK, "MAX_ALLOWANCE", "115792089237316195423570985008687907853269984665640564039457584007913129639935");

var Uint = /*#__PURE__*/function () {
  function Uint() {
    _classCallCheck(this, Uint);
  }

  _createClass(Uint, null, [{
    key: "validate",
    value: function validate(value) {
      if (value < 0 || !Number.isSafeInteger(value)) {
        throw ErrorType.Format_InvalidUInt;
      }
    }
  }, {
    key: "validateAll",
    value: function validateAll(values) {
      if (values.some(function (value) {
        return value < 0 || !Number.isSafeInteger(value);
      })) {
        throw ErrorType.Format_InvalidUInt;
      }
    }
  }]);

  return Uint;
}();

var Erc1155SDK = /*#__PURE__*/function (_ContractSDK) {
  _inherits(Erc1155SDK, _ContractSDK);

  var _super = _createSuper(Erc1155SDK);

  function Erc1155SDK() {
    _classCallCheck(this, Erc1155SDK);

    return _super.apply(this, arguments);
  }

  _createClass(Erc1155SDK, [{
    key: "getTokenBalance",
    value: function () {
      var _getTokenBalance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tokenId) {
        var caller;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Uint.validate(tokenId);
                _context.next = 3;
                return this.signer.getAddress();

              case 3:
                caller = _context.sent;
                return _context.abrupt("return", this.contract.balanceOf(caller, tokenId));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTokenBalance(_x) {
        return _getTokenBalance.apply(this, arguments);
      }

      return getTokenBalance;
    }()
  }, {
    key: "getTokenBalanceOf",
    value: function () {
      var _getTokenBalanceOf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(user, tokenId) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Uint.validate(tokenId);
                return _context2.abrupt("return", this.contract.balanceOf(user, tokenId));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTokenBalanceOf(_x2, _x3) {
        return _getTokenBalanceOf.apply(this, arguments);
      }

      return getTokenBalanceOf;
    }()
  }, {
    key: "transferToken",
    value: function () {
      var _transferToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(to, tokenId, quantity) {
        var caller, balance, tx;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Uint.validate(tokenId);
                _context3.next = 3;
                return this.signer.getAddress();

              case 3:
                caller = _context3.sent;
                _context3.next = 6;
                return this.contract.balanceOf(caller, tokenId);

              case 6:
                balance = _context3.sent;

                if (!balance.lt(quantity)) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", Promise.reject(ErrorType.Token_InsufficientBalance));

              case 9:
                _context3.next = 11;
                return this.contract.safeTransferFrom(caller, to, tokenId, quantity, []);

              case 11:
                tx = _context3.sent;
                _context3.next = 14;
                return tx.wait(this.confirmBlocks);

              case 14:
                return _context3.abrupt("return", _context3.sent);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function transferToken(_x4, _x5, _x6) {
        return _transferToken.apply(this, arguments);
      }

      return transferToken;
    }()
  }, {
    key: "transferTokenBatch",
    value: function () {
      var _transferTokenBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(to, tokens) {
        var tokenIds, caller, tx;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                tokenIds = tokens.map(function (token) {
                  Uint.validate(token.tokenId);
                  return token.tokenId;
                });
                _context4.next = 3;
                return this.signer.getAddress();

              case 3:
                caller = _context4.sent;
                _context4.next = 6;
                return this.contract.safeBatchTransferFrom(caller, to, tokenIds, tokens.map(function (it) {
                  return it.quantity;
                }), []);

              case 6:
                tx = _context4.sent;
                _context4.next = 9;
                return tx.wait(this.confirmBlocks);

              case 9:
                return _context4.abrupt("return", _context4.sent);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function transferTokenBatch(_x7, _x8) {
        return _transferTokenBatch.apply(this, arguments);
      }

      return transferTokenBatch;
    }()
  }, {
    key: "setTokenTransferApproval",
    value: function () {
      var _setTokenTransferApproval = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(to, status) {
        var tx;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.contract.setApprovalForAll(to, status);

              case 2:
                tx = _context5.sent;
                _context5.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setTokenTransferApproval(_x9, _x10) {
        return _setTokenTransferApproval.apply(this, arguments);
      }

      return setTokenTransferApproval;
    }()
  }, {
    key: "transferTokenFrom",
    value: function () {
      var _transferTokenFrom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(from, to, tokenId, quantity) {
        var caller, balance, tx;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                Uint.validate(tokenId);
                _context6.next = 3;
                return this.signer.getAddress();

              case 3:
                caller = _context6.sent;
                _context6.next = 6;
                return this.contract.balanceOf(caller, tokenId);

              case 6:
                balance = _context6.sent;

                if (!balance.lt(quantity)) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("return", Promise.reject(ErrorType.Token_InsufficientBalance));

              case 9:
                _context6.next = 11;
                return this.contract.safeTransferFrom(from, to, tokenId, quantity, []);

              case 11:
                tx = _context6.sent;
                _context6.next = 14;
                return tx.wait(this.confirmBlocks);

              case 14:
                return _context6.abrupt("return", _context6.sent);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function transferTokenFrom(_x11, _x12, _x13, _x14) {
        return _transferTokenFrom.apply(this, arguments);
      }

      return transferTokenFrom;
    }()
  }, {
    key: "transferTokenFromBatch",
    value: function () {
      var _transferTokenFromBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(from, to, tokens) {
        var tx;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.contract.safeBatchTransferFrom(from, to, tokens.map(function (it) {
                  return it.tokenId;
                }), tokens.map(function (it) {
                  return it.quantity;
                }), []);

              case 2:
                tx = _context7.sent;
                _context7.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context7.abrupt("return", _context7.sent);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function transferTokenFromBatch(_x15, _x16, _x17) {
        return _transferTokenFromBatch.apply(this, arguments);
      }

      return transferTokenFromBatch;
    }()
  }]);

  return Erc1155SDK;
}(ContractSDK);

var Erc721SDK = /*#__PURE__*/function (_ContractSDK) {
  _inherits(Erc721SDK, _ContractSDK);

  var _super = _createSuper(Erc721SDK);

  function Erc721SDK() {
    _classCallCheck(this, Erc721SDK);

    return _super.apply(this, arguments);
  }

  _createClass(Erc721SDK, [{
    key: "balanceOf",
    value:
    /**
     * @dev Returns the number of tokens in ``owner``'s account.
     */
    function () {
      var _balanceOf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(owner) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.contract.balanceOf(owner);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function balanceOf(_x) {
        return _balanceOf.apply(this, arguments);
      }

      return balanceOf;
    }()
    /**
     * @dev Returns the owner of the `tokenId` token.
     *
     * Requirements:
     *
     * - `tokenId` must exist.
     */

  }, {
    key: "ownerOf",
    value: function () {
      var _ownerOf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tokenId) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.contract.ownerOf(tokenId);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function ownerOf(_x2) {
        return _ownerOf.apply(this, arguments);
      }

      return ownerOf;
    }()
    /**
     * @dev Transfers `tokenId` from caller to `to`.
     *
     * Requirements:
     *
     * - `to` cannot be the zero address.
     * - `tokenId` token must be owned by `from`.
     *
     * Emits a {Transfer} event.
     */

  }, {
    key: "safeTransferToken",
    value: function () {
      var _safeTransferToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(to, tokenId) {
        var caller;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Uint.validate(tokenId);
                _context3.next = 3;
                return this.signer.getAddress();

              case 3:
                caller = _context3.sent;
                _context3.next = 6;
                return this.safeTransferFrom(caller, to, tokenId);

              case 6:
                return _context3.abrupt("return", _context3.sent);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function safeTransferToken(_x3, _x4) {
        return _safeTransferToken.apply(this, arguments);
      }

      return safeTransferToken;
    }()
    /**
     * @dev Safely transfers `tokenId` token from `from` to `to`, checking first that contract recipients
     * are aware of the ERC721 protocol to prevent tokens from being forever locked.
     *
     * Requirements:
     *
     * - `from` cannot be the zero address.
     * - `to` cannot be the zero address.
     * - `tokenId` token must exist and be owned by `from`.
     * - If the caller is not `from`, it must be have been allowed to move this token by either {approve} or {setApprovalForAll}.
     * - If `to` refers to a smart contract, it must implement {IERC721Receiver-onERC721Received}, which is called upon a safe transfer.
     *
     * Emits a {Transfer} event.
     */

  }, {
    key: "safeTransferFrom",
    value: function () {
      var _safeTransferFrom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(from, to, tokenId) {
        var tx;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.contract.safeTransferFrom(from, to, tokenId);

              case 2:
                tx = _context4.sent;
                _context4.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function safeTransferFrom(_x5, _x6, _x7) {
        return _safeTransferFrom.apply(this, arguments);
      }

      return safeTransferFrom;
    }()
    /**
     * @dev Gives permission to `to` to transfer `tokenId` token to another account.
     * The approval is cleared when the token is transferred.
     *
     * Only a single account can be approved at a time, so approving the zero address clears previous approvals.
     *
     * Requirements:
     *
     * - The caller must own the token or be an approved operator.
     * - `tokenId` must exist.
     *
     * Emits an {Approval} event.
     */

  }, {
    key: "approve",
    value: function () {
      var _approve = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(to, tokenId) {
        var tx;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.contract.approve(to, tokenId);

              case 2:
                tx = _context5.sent;
                _context5.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function approve(_x8, _x9) {
        return _approve.apply(this, arguments);
      }

      return approve;
    }()
    /**
     * @dev Approve or remove `operator` as an operator for the caller.
     * Operators can call {transferFrom} or {safeTransferFrom} for any token owned by the caller.
     *
     * Requirements:
     *
     * - The `operator` cannot be the caller.
     *
     * Emits an {ApprovalForAll} event.
     */

  }, {
    key: "setApprovalForAll",
    value: function () {
      var _setApprovalForAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(operator, approved) {
        var tx;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.contract.setApprovalForAll(operator, approved);

              case 2:
                tx = _context6.sent;
                _context6.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context6.abrupt("return", _context6.sent);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setApprovalForAll(_x10, _x11) {
        return _setApprovalForAll.apply(this, arguments);
      }

      return setApprovalForAll;
    }()
    /**
     * @dev Returns the account approved for `tokenId` token.
     *
     * Requirements:
     *
     * - `tokenId` must exist.
     */

  }, {
    key: "getApproved",
    value: function () {
      var _getApproved = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(tokenId) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.contract.getApproved(tokenId);

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getApproved(_x12) {
        return _getApproved.apply(this, arguments);
      }

      return getApproved;
    }()
    /**
     * @dev Returns if the `operator` is allowed to manage all of the assets of `owner`.
     *
     * See {setApprovalForAll}
     */

  }, {
    key: "isApprovedForAll",
    value: function () {
      var _isApprovedForAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(owner, operator) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.contract.isApprovedForAll(owner, operator);

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function isApprovedForAll(_x13, _x14) {
        return _isApprovedForAll.apply(this, arguments);
      }

      return isApprovedForAll;
    }()
  }]);

  return Erc721SDK;
}(ContractSDK);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

function execute(callback) {
  if (callback !== undefined && callback !== null) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    return callback.apply(void 0, params);
  }

  return null;
}

var BuyStatus;

(function (BuyStatus) {
  BuyStatus[BuyStatus["REQUIREMENT_SUCCESS"] = 0] = "REQUIREMENT_SUCCESS";
  BuyStatus[BuyStatus["PUBLISH_BUY"] = 1] = "PUBLISH_BUY";
})(BuyStatus || (BuyStatus = {}));

/**
 * Gen1 Collectible using ERC1155 hosting the first sale of Posters and airdrop of Badges
 * New NFTs will be hosted in a new contract using ERC721
 */
var CollectiblesSDK = /*#__PURE__*/function (_Erc1155SDK) {
  _inherits(CollectiblesSDK, _Erc1155SDK);

  var _super = _createSuper(CollectiblesSDK);

  function CollectiblesSDK(signer, contractAddress) {
    _classCallCheck(this, CollectiblesSDK);

    return _super.call(this, signer, contractAddress, DelysiumAbi);
  }

  _createClass(CollectiblesSDK, [{
    key: "connectSigner",
    value: function connectSigner(signer) {
      _get(_getPrototypeOf(CollectiblesSDK.prototype), "connectSigner", this).call(this, signer);
    }
    /** Purchase */

  }, {
    key: "hasSupply",
    value: function () {
      var _hasSupply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tokenId, quantity) {
        var item;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Uint.validate(tokenId);
                _context.next = 3;
                return this.getItem(tokenId);

              case 3:
                item = _context.sent;
                return _context.abrupt("return", this.itemHasSupply(item, quantity));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function hasSupply(_x, _x2) {
        return _hasSupply.apply(this, arguments);
      }

      return hasSupply;
    }()
  }, {
    key: "itemHasSupply",
    value: function () {
      var _itemHasSupply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item, quantity) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", item.numSold.add(quantity).lte(item.maxSupply));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function itemHasSupply(_x3, _x4) {
        return _itemHasSupply.apply(this, arguments);
      }

      return itemHasSupply;
    }()
  }, {
    key: "preOrder",
    value: function () {
      var _preOrder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(tokenId, quantity, statusEvent) {
        var item, caller, preOrderLimit, preOrderConsumed, tx;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Uint.validate(tokenId);
                _context3.next = 3;
                return this.getItem(tokenId);

              case 3:
                item = _context3.sent;
                _context3.next = 6;
                return this.signer.getAddress();

              case 6:
                caller = _context3.sent;
                _context3.next = 9;
                return this.getPreOrderLimit(caller, tokenId);

              case 9:
                preOrderLimit = _context3.sent;
                _context3.next = 12;
                return this.getPreOrderConsumed(caller, tokenId);

              case 12:
                preOrderConsumed = _context3.sent;

                if (!preOrderConsumed.add(quantity).gt(preOrderLimit)) {
                  _context3.next = 15;
                  break;
                }

                return _context3.abrupt("return", Promise.reject(ErrorType.PreOrder_NoSupply));

              case 15:
                _context3.next = 17;
                return this.itemHasSupply(item, quantity);

              case 17:
                if (_context3.sent) {
                  _context3.next = 19;
                  break;
                }

                return _context3.abrupt("return", Promise.reject(ErrorType.Token_NoSupply));

              case 19:
                _context3.next = 21;
                return this.hasBalanceFor(caller, item.price.mul(quantity));

              case 21:
                if (_context3.sent) {
                  _context3.next = 23;
                  break;
                }

                return _context3.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientBalance));

              case 23:
                _context3.next = 25;
                return this.adjustAllowance(item.price.mul(quantity));

              case 25:
                if (_context3.sent) {
                  _context3.next = 27;
                  break;
                }

                return _context3.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientAllowance));

              case 27:
                execute(statusEvent, BuyStatus.REQUIREMENT_SUCCESS);
                _context3.next = 30;
                return this.contract.preorder(tokenId, quantity);

              case 30:
                tx = _context3.sent;
                execute(statusEvent, BuyStatus.PUBLISH_BUY);
                _context3.next = 34;
                return tx.wait(this.confirmBlocks);

              case 34:
                return _context3.abrupt("return", _context3.sent);

              case 35:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function preOrder(_x5, _x6, _x7) {
        return _preOrder.apply(this, arguments);
      }

      return preOrder;
    }()
  }, {
    key: "buy",
    value: function () {
      var _buy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(tokenId, quantity, statusEvent) {
        var item, caller, tx, _final;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                Uint.validate(tokenId); //console.log("[BUY] start: ", new Date())
                //let start = Date.now()

                _context4.next = 3;
                return this.getItem(tokenId);

              case 3:
                item = _context4.sent;
                _context4.next = 6;
                return this.signer.getAddress();

              case 6:
                caller = _context4.sent;
                _context4.next = 9;
                return this.itemHasSupply(item, quantity);

              case 9:
                if (_context4.sent) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", Promise.reject(ErrorType.Token_NoSupply));

              case 11:
                _context4.next = 13;
                return this.hasBalanceFor(caller, item.price.mul(quantity));

              case 13:
                if (_context4.sent) {
                  _context4.next = 15;
                  break;
                }

                return _context4.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientBalance));

              case 15:
                _context4.next = 17;
                return this.adjustAllowance(item.price.mul(quantity));

              case 17:
                if (_context4.sent) {
                  _context4.next = 19;
                  break;
                }

                return _context4.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientAllowance));

              case 19:
                //end = Date.now()
                //console.log(`[BUY] adjustBalance: ${(end - start) / 1000}s`)
                execute(statusEvent, BuyStatus.REQUIREMENT_SUCCESS); //start = Date.now()

                _context4.next = 22;
                return this.contract.buy(tokenId, quantity);

              case 22:
                tx = _context4.sent;
                //end = Date.now()
                //console.log(`[BUY] start buy: ${(end - start) / 1000}s`)
                execute(statusEvent, BuyStatus.PUBLISH_BUY); //start = Date.now()

                _context4.next = 26;
                return tx.wait(this.confirmBlocks);

              case 26:
                _final = _context4.sent;
                return _context4.abrupt("return", _final);

              case 28:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function buy(_x8, _x9, _x10) {
        return _buy.apply(this, arguments);
      }

      return buy;
    }()
    /** Pre-Sale */

  }, {
    key: "airDrop",
    value: function () {
      var _airDrop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(receivers) {
        var tx;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.contract.airDrop(receivers);

              case 2:
                tx = _context5.sent;
                _context5.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function airDrop(_x11) {
        return _airDrop.apply(this, arguments);
      }

      return airDrop;
    }()
  }, {
    key: "addToWhiteList",
    value: function () {
      var _addToWhiteList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(addresses) {
        var tx;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.contract.addToWhiteList(addresses);

              case 2:
                tx = _context6.sent;
                _context6.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context6.abrupt("return", _context6.sent);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function addToWhiteList(_x12) {
        return _addToWhiteList.apply(this, arguments);
      }

      return addToWhiteList;
    }()
  }, {
    key: "getPreOrderLimit",
    value: function () {
      var _getPreOrderLimit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(account, tokenId) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                Uint.validate(tokenId);
                _context7.t0 = BigNumber;
                _context7.next = 4;
                return this.contract.whiteListInfo(tokenId, account);

              case 4:
                _context7.t1 = _context7.sent;
                return _context7.abrupt("return", _context7.t0.from.call(_context7.t0, _context7.t1));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getPreOrderLimit(_x13, _x14) {
        return _getPreOrderLimit.apply(this, arguments);
      }

      return getPreOrderLimit;
    }()
  }, {
    key: "getPreOrderConsumed",
    value: function () {
      var _getPreOrderConsumed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(account, tokenId) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                Uint.validate(tokenId);
                _context8.t0 = BigNumber;
                _context8.next = 4;
                return this.contract.numPreorders(tokenId, account);

              case 4:
                _context8.t1 = _context8.sent;
                return _context8.abrupt("return", _context8.t0.from.call(_context8.t0, _context8.t1));

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getPreOrderConsumed(_x15, _x16) {
        return _getPreOrderConsumed.apply(this, arguments);
      }

      return getPreOrderConsumed;
    }()
    /** Items */

  }, {
    key: "formatItem",
    value: function formatItem(item) {
      var keys = Object.keys(item);
      return keys.reduce(function (ret, key) {
        if (/[a-zA-Z]+/mgi.test(key)) {
          ret[key] = item[key];
        }

        return ret;
      }, {});
    }
  }, {
    key: "getItemsMapped",
    value: function () {
      var _getItemsMapped = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _this = this;

        var data, ids, values, result;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.contract.getItemAll();

              case 2:
                data = _context9.sent;
                ids = data[0];
                values = data[1].map(function (it) {
                  return _this.formatItem(it);
                });

                if (!(ids.length != values.length)) {
                  _context9.next = 7;
                  break;
                }

                return _context9.abrupt("return", Promise.reject("missing id to item mapping"));

              case 7:
                result = {};
                ids.forEach(function (id, index) {
                  return result[id] = values[index];
                });
                return _context9.abrupt("return", result);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getItemsMapped() {
        return _getItemsMapped.apply(this, arguments);
      }

      return getItemsMapped;
    }()
  }, {
    key: "getItem",
    value: function () {
      var _getItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(tokenId) {
        var result;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                Uint.validate(tokenId);
                _context10.next = 3;
                return this.contract.getItem(tokenId);

              case 3:
                result = _context10.sent;
                return _context10.abrupt("return", this.formatItem(result));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getItem(_x17) {
        return _getItem.apply(this, arguments);
      }

      return getItem;
    }()
  }, {
    key: "getItems",
    value: function () {
      var _getItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(tokenIds) {
        var _this2 = this;

        var result;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                Uint.validateAll(tokenIds);
                _context11.next = 3;
                return this.contract.getItems(tokenIds);

              case 3:
                result = _context11.sent;
                return _context11.abrupt("return", result.map(function (it) {
                  return _this2.formatItem(it);
                }));

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getItems(_x18) {
        return _getItems.apply(this, arguments);
      }

      return getItems;
    }()
  }, {
    key: "getItemAll",
    value: function () {
      var _getItemAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _this3 = this;

        var result;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.contract.getItemAll();

              case 2:
                result = _context12.sent;
                return _context12.abrupt("return", result.map(function (it) {
                  return _this3.formatItem(it);
                }));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getItemAll() {
        return _getItemAll.apply(this, arguments);
      }

      return getItemAll;
    }()
  }, {
    key: "setItems",
    value: function () {
      var _setItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(items) {
        var tx;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.contract.setItems(items);

              case 2:
                tx = _context13.sent;
                _context13.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context13.abrupt("return", _context13.sent);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setItems(_x19) {
        return _setItems.apply(this, arguments);
      }

      return setItems;
    }()
  }, {
    key: "removeItems",
    value: function () {
      var _removeItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(ids) {
        var tx;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                ids.forEach(function (id) {
                  return Uint.validate(id);
                });
                _context14.next = 3;
                return this.contract.removeItems(ids);

              case 3:
                tx = _context14.sent;
                _context14.next = 6;
                return tx.wait(this.confirmBlocks);

              case 6:
                return _context14.abrupt("return", _context14.sent);

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function removeItems(_x20) {
        return _removeItems.apply(this, arguments);
      }

      return removeItems;
    }()
    /** Roles */

  }, {
    key: "addMaintainRole",
    value: function () {
      var _addMaintainRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(maintainer) {
        var tx;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.contract.addMaintainRole(maintainer);

              case 2:
                tx = _context15.sent;
                _context15.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context15.abrupt("return", _context15.sent);

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function addMaintainRole(_x21) {
        return _addMaintainRole.apply(this, arguments);
      }

      return addMaintainRole;
    }()
  }, {
    key: "removeMaintainRole",
    value: function () {
      var _removeMaintainRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(maintainer) {
        var tx;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.contract.removeMaintainRole(maintainer);

              case 2:
                tx = _context16.sent;
                _context16.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context16.abrupt("return", _context16.sent);

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function removeMaintainRole(_x22) {
        return _removeMaintainRole.apply(this, arguments);
      }

      return removeMaintainRole;
    }()
  }, {
    key: "grantRole",
    value: function () {
      var _grantRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.contract.grantRole(role, account);

              case 2:
                tx = _context17.sent;
                _context17.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context17.abrupt("return", _context17.sent);

              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function grantRole(_x23, _x24) {
        return _grantRole.apply(this, arguments);
      }

      return grantRole;
    }()
  }, {
    key: "revokeRole",
    value: function () {
      var _revokeRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.contract.revokeRole(role, account);

              case 2:
                tx = _context18.sent;
                _context18.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context18.abrupt("return", _context18.sent);

              case 6:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function revokeRole(_x25, _x26) {
        return _revokeRole.apply(this, arguments);
      }

      return revokeRole;
    }()
  }, {
    key: "hasRole",
    value: function () {
      var _hasRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(role, account) {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.contract.hasRole(role, account);

              case 2:
                return _context19.abrupt("return", _context19.sent);

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function hasRole(_x27, _x28) {
        return _hasRole.apply(this, arguments);
      }

      return hasRole;
    }()
  }, {
    key: "gotRole",
    value: function () {
      var _gotRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(role) {
        var caller;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context20.sent;
                _context20.next = 5;
                return this.hasRole(role, caller);

              case 5:
                return _context20.abrupt("return", _context20.sent);

              case 6:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function gotRole(_x29) {
        return _gotRole.apply(this, arguments);
      }

      return gotRole;
    }()
    /** Configuration */

  }, {
    key: "setURI",
    value: function () {
      var _setURI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(newUri) {
        var tx;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.contract.setURI(newUri);

              case 2:
                tx = _context21.sent;
                _context21.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context21.abrupt("return", _context21.sent);

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function setURI(_x30) {
        return _setURI.apply(this, arguments);
      }

      return setURI;
    }()
  }, {
    key: "uri",
    value: function () {
      var _uri = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(tokenId) {
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                Uint.validate(tokenId);
                _context22.next = 3;
                return this.contract.uri(tokenId);

              case 3:
                return _context22.abrupt("return", _context22.sent);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function uri(_x31) {
        return _uri.apply(this, arguments);
      }

      return uri;
    }()
  }, {
    key: "setMetadataHashes",
    value: function () {
      var _setMetadataHashes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(ids, hashes) {
        var tx;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                ids.forEach(function (id) {
                  return Uint.validate(id);
                });
                _context23.next = 3;
                return this.contract.setMetadataHashes(ids, hashes);

              case 3:
                tx = _context23.sent;
                _context23.next = 6;
                return tx.wait(this.confirmBlocks);

              case 6:
                return _context23.abrupt("return", _context23.sent);

              case 7:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function setMetadataHashes(_x32, _x33) {
        return _setMetadataHashes.apply(this, arguments);
      }

      return setMetadataHashes;
    }()
  }, {
    key: "setPaymentToken",
    value: function () {
      var _setPaymentToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(tokenAddress) {
        var tx;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.contract.setPaymentToken(tokenAddress);

              case 2:
                tx = _context24.sent;
                _context24.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context24.abrupt("return", _context24.sent);

              case 6:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function setPaymentToken(_x34) {
        return _setPaymentToken.apply(this, arguments);
      }

      return setPaymentToken;
    }()
    /** Management **/

  }, {
    key: "pause",
    value: function () {
      var _pause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var tx;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this.contract.pause();

              case 2:
                tx = _context25.sent;
                _context25.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context25.abrupt("return", _context25.sent);

              case 6:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function pause() {
        return _pause.apply(this, arguments);
      }

      return pause;
    }()
  }, {
    key: "unpause",
    value: function () {
      var _unpause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var tx;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.contract.unpause();

              case 2:
                tx = _context26.sent;
                _context26.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context26.abrupt("return", _context26.sent);

              case 6:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function unpause() {
        return _unpause.apply(this, arguments);
      }

      return unpause;
    }()
    /** Accounting */

  }, {
    key: "balance",
    value: function () {
      var _balance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.balanceOf(this.contractAddress);

              case 2:
                return _context27.abrupt("return", _context27.sent);

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function balance() {
        return _balance.apply(this, arguments);
      }

      return balance;
    }()
  }, {
    key: "withdrawToken",
    value: function () {
      var _withdrawToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(to, amount) {
        var tx;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.contract.withdrawToken(to, amount);

              case 2:
                tx = _context28.sent;
                _context28.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context28.abrupt("return", _context28.sent);

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function withdrawToken(_x35, _x36) {
        return _withdrawToken.apply(this, arguments);
      }

      return withdrawToken;
    }()
    /** 3rd PaymentToken interaction */

  }, {
    key: "balanceOf",
    value: function () {
      var _balanceOf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(address) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context29.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context29.t0 = BigNumber;
                _context29.next = 7;
                return paymentToken.balanceOf(address);

              case 7:
                _context29.t1 = _context29.sent;
                return _context29.abrupt("return", _context29.t0.from.call(_context29.t0, _context29.t1));

              case 9:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function balanceOf(_x37) {
        return _balanceOf.apply(this, arguments);
      }

      return balanceOf;
    }()
  }, {
    key: "hasBalanceFor",
    value: function () {
      var _hasBalanceFor = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(caller, amount) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context30.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context30.next = 6;
                return paymentToken.hasBalanceFor(caller, amount);

              case 6:
                return _context30.abrupt("return", _context30.sent);

              case 7:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function hasBalanceFor(_x38, _x39) {
        return _hasBalanceFor.apply(this, arguments);
      }

      return hasBalanceFor;
    }()
  }, {
    key: "adjustAllowance",
    value: function () {
      var _adjustAllowance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31(amount) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context31.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context31.next = 6;
                return paymentToken.adjustAllowance(this.contractAddress, amount);

              case 6:
                return _context31.abrupt("return", _context31.sent);

              case 7:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function adjustAllowance(_x40) {
        return _adjustAllowance.apply(this, arguments);
      }

      return adjustAllowance;
    }()
  }]);

  return CollectiblesSDK;
}(Erc1155SDK);

var AssetsSDK = /*#__PURE__*/function (_Erc721SDK) {
  _inherits(AssetsSDK, _Erc721SDK);

  var _super = _createSuper(AssetsSDK);

  function AssetsSDK(signer, contractAddress) {
    _classCallCheck(this, AssetsSDK);

    return _super.call(this, signer, contractAddress, DelysiumAssetsAbi);
  }
  /** Management **/


  _createClass(AssetsSDK, [{
    key: "pause",
    value: function () {
      var _pause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tx;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.contract.pause();

              case 2:
                tx = _context.sent;
                _context.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function pause() {
        return _pause.apply(this, arguments);
      }

      return pause;
    }()
  }, {
    key: "unpause",
    value: function () {
      var _unpause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tx;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.contract.unpause();

              case 2:
                tx = _context2.sent;
                _context2.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unpause() {
        return _unpause.apply(this, arguments);
      }

      return unpause;
    }()
    /** Configuration */

  }, {
    key: "baseURI",
    value: function () {
      var _baseURI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.contract.baseURI();

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function baseURI() {
        return _baseURI.apply(this, arguments);
      }

      return baseURI;
    }()
  }, {
    key: "tokenURI",
    value: function () {
      var _tokenURI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(tokenId) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                Uint.validate(tokenId);
                _context4.next = 3;
                return this.contract.tokenURI(tokenId);

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function tokenURI(_x) {
        return _tokenURI.apply(this, arguments);
      }

      return tokenURI;
    }()
  }, {
    key: "modelURI",
    value: function () {
      var _modelURI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(modelId) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                Uint.validate(modelId);
                _context5.next = 3;
                return this.contract.modelURI(modelId);

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function modelURI(_x2) {
        return _modelURI.apply(this, arguments);
      }

      return modelURI;
    }()
  }, {
    key: "setBaseURI",
    value: function () {
      var _setBaseURI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(newBaseURI) {
        var tx;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.contract.setBaseURI(newBaseURI);

              case 2:
                tx = _context6.sent;
                _context6.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context6.abrupt("return", _context6.sent);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setBaseURI(_x3) {
        return _setBaseURI.apply(this, arguments);
      }

      return setBaseURI;
    }()
  }, {
    key: "setModelURI",
    value: function () {
      var _setModelURI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(modelId, modelURI) {
        var tx;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.contract.setModelURI(modelId, modelURI);

              case 2:
                tx = _context7.sent;
                _context7.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context7.abrupt("return", _context7.sent);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setModelURI(_x4, _x5) {
        return _setModelURI.apply(this, arguments);
      }

      return setModelURI;
    }()
  }, {
    key: "setModelURIBatch",
    value: function () {
      var _setModelURIBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(ids, uris) {
        var tx;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(ids.length != uris.length)) {
                  _context8.next = 2;
                  break;
                }

                throw ErrorType.Format_InvalidParameter;

              case 2:
                _context8.next = 4;
                return this.contract.setModelURIBatch(ids, uris);

              case 4:
                tx = _context8.sent;
                _context8.next = 7;
                return tx.wait(this.confirmBlocks);

              case 7:
                return _context8.abrupt("return", _context8.sent);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setModelURIBatch(_x6, _x7) {
        return _setModelURIBatch.apply(this, arguments);
      }

      return setModelURIBatch;
    }()
  }, {
    key: "setTokenDataBatch",
    value: function () {
      var _setTokenDataBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(tokenIds, data) {
        var tx;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(tokenIds.length != data.length)) {
                  _context9.next = 2;
                  break;
                }

                throw ErrorType.Format_InvalidParameter;

              case 2:
                _context9.next = 4;
                return this.contract.setTokenDataBatch(tokenIds, data);

              case 4:
                tx = _context9.sent;
                _context9.next = 7;
                return tx.wait(this.confirmBlocks);

              case 7:
                return _context9.abrupt("return", _context9.sent);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setTokenDataBatch(_x8, _x9) {
        return _setTokenDataBatch.apply(this, arguments);
      }

      return setTokenDataBatch;
    }()
    /** Mint */

  }, {
    key: "mint",
    value: function () {
      var _mint = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(to, modelId, amount) {
        var tx;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.contract.mint(to, modelId, amount);

              case 2:
                tx = _context10.sent;
                _context10.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context10.abrupt("return", _context10.sent);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function mint(_x10, _x11, _x12) {
        return _mint.apply(this, arguments);
      }

      return mint;
    }()
  }, {
    key: "mintBatch",
    value: function () {
      var _mintBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(receivers) {
        var tx;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.contract.mintBatch(receivers);

              case 2:
                tx = _context11.sent;
                _context11.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context11.abrupt("return", _context11.sent);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function mintBatch(_x13) {
        return _mintBatch.apply(this, arguments);
      }

      return mintBatch;
    }()
    /** Tokens */

  }, {
    key: "modelMinted",
    value: function () {
      var _modelMinted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(modelId) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                Uint.validate(modelId);
                _context12.t0 = BigNumber;
                _context12.next = 4;
                return this.contract.modelMinted(modelId);

              case 4:
                _context12.t1 = _context12.sent;
                return _context12.abrupt("return", _context12.t0.from.call(_context12.t0, _context12.t1));

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function modelMinted(_x14) {
        return _modelMinted.apply(this, arguments);
      }

      return modelMinted;
    }()
  }, {
    key: "getModelId",
    value: function () {
      var _getModelId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(tokenId) {
        var result;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                Uint.validate(tokenId);
                _context13.next = 3;
                return this.contract.getModelId(tokenId);

              case 3:
                result = _context13.sent;
                return _context13.abrupt("return", result.toNumber());

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getModelId(_x15) {
        return _getModelId.apply(this, arguments);
      }

      return getModelId;
    }()
  }, {
    key: "tokenData",
    value: function () {
      var _tokenData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(tokenId) {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                Uint.validate(tokenId);
                _context14.next = 3;
                return this.contract.getModelId(tokenId);

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function tokenData(_x16) {
        return _tokenData.apply(this, arguments);
      }

      return tokenData;
    }()
    /** Transfer */

  }, {
    key: "safeTransferFromBatch",
    value: function () {
      var _safeTransferFromBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(from, to, tokenIds) {
        var tx;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.contract.setTokenDataBatch(from, to, tokenIds);

              case 2:
                tx = _context15.sent;
                _context15.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context15.abrupt("return", _context15.sent);

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function safeTransferFromBatch(_x17, _x18, _x19) {
        return _safeTransferFromBatch.apply(this, arguments);
      }

      return safeTransferFromBatch;
    }()
  }, {
    key: "safeTransferFromToAddresses",
    value: function () {
      var _safeTransferFromToAddresses = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(from, receivers) {
        var addresses, tokenIds, tx;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                addresses = [];
                tokenIds = [];
                receivers.forEach(function (receiver) {
                  addresses.push(receiver.receiver);
                  tokenIds.push(receiver.tokenId);
                });
                _context16.next = 5;
                return this.contract.safeTransferFromToAddresses(from, addresses, tokenIds);

              case 5:
                tx = _context16.sent;
                _context16.next = 8;
                return tx.wait(this.confirmBlocks);

              case 8:
                return _context16.abrupt("return", _context16.sent);

              case 9:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function safeTransferFromToAddresses(_x20, _x21) {
        return _safeTransferFromToAddresses.apply(this, arguments);
      }

      return safeTransferFromToAddresses;
    }()
    /** Role */

  }, {
    key: "setAsMaintainer",
    value: function () {
      var _setAsMaintainer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(maintainer) {
        var role;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                role = keccak256(toUtf8Bytes("MAINTAINER_ROLE"));
                _context17.next = 3;
                return this.grantRole(role, maintainer);

              case 3:
                return _context17.abrupt("return", _context17.sent);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function setAsMaintainer(_x22) {
        return _setAsMaintainer.apply(this, arguments);
      }

      return setAsMaintainer;
    }()
  }, {
    key: "removeMaintainRole",
    value: function () {
      var _removeMaintainRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(maintainer) {
        var role;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                role = keccak256(toUtf8Bytes("MAINTAINER_ROLE"));
                _context18.next = 3;
                return this.revokeRole(role, maintainer);

              case 3:
                return _context18.abrupt("return", _context18.sent);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function removeMaintainRole(_x23) {
        return _removeMaintainRole.apply(this, arguments);
      }

      return removeMaintainRole;
    }()
  }, {
    key: "grantRole",
    value: function () {
      var _grantRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.contract.grantRole(role, account);

              case 2:
                tx = _context19.sent;
                _context19.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context19.abrupt("return", _context19.sent);

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function grantRole(_x24, _x25) {
        return _grantRole.apply(this, arguments);
      }

      return grantRole;
    }()
  }, {
    key: "revokeRole",
    value: function () {
      var _revokeRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.contract.revokeRole(role, account);

              case 2:
                tx = _context20.sent;
                _context20.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context20.abrupt("return", _context20.sent);

              case 6:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function revokeRole(_x26, _x27) {
        return _revokeRole.apply(this, arguments);
      }

      return revokeRole;
    }()
  }, {
    key: "hasRole",
    value: function () {
      var _hasRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(role, account) {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.contract.hasRole(role, account);

              case 2:
                return _context21.abrupt("return", _context21.sent);

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function hasRole(_x28, _x29) {
        return _hasRole.apply(this, arguments);
      }

      return hasRole;
    }()
  }, {
    key: "gotRole",
    value: function () {
      var _gotRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(role) {
        var caller;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context22.sent;
                _context22.next = 5;
                return this.hasRole(role, caller);

              case 5:
                return _context22.abrupt("return", _context22.sent);

              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function gotRole(_x30) {
        return _gotRole.apply(this, arguments);
      }

      return gotRole;
    }()
  }]);

  return AssetsSDK;
}(Erc721SDK);

var isNull = function isNull(data) {
  return data === undefined || data === null;
};
var isNotNull = function isNotNull(data) {
  return !isNull(data);
};
var throwIf = function throwIf(condition, error) {
  if (condition) {
    throw Error(error);
  }
};
var throwIfNull = function throwIfNull(data, error) {
  if (isNull(data)) {
    throw Error(error);
  }
};

var StoreSDK = /*#__PURE__*/function (_ContractSDK) {
  _inherits(StoreSDK, _ContractSDK);

  var _super = _createSuper(StoreSDK);

  function StoreSDK(signer, contractAddress, assetsAddress) {
    var _this;

    _classCallCheck(this, StoreSDK);

    _this = _super.call(this, signer, contractAddress, DelysiumStoreAbi);
    _this.assets = new AssetsSDK(signer, assetsAddress);
    return _this;
  }
  /** Items */


  _createClass(StoreSDK, [{
    key: "formatItem",
    value: function formatItem(item) {
      var keys = Object.keys(item);
      return keys.reduce(function (ret, key) {
        if (/[a-zA-Z]+/gim.test(key)) {
          ret[key] = item[key];
        }

        return ret;
      }, {});
    }
  }, {
    key: "getItem",
    value: function () {
      var _getItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Uint.validate(id);
                _context.next = 3;
                return this.getItems([id]);

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result[0]);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getItem(_x) {
        return _getItem.apply(this, arguments);
      }

      return getItem;
    }()
  }, {
    key: "getItems",
    value: function () {
      var _getItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ids) {
        var _this2 = this;

        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Uint.validateAll(ids);
                _context2.next = 3;
                return this.contract.getItems(ids);

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", result.map(function (it) {
                  return _this2.formatItem(it);
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getItems(_x2) {
        return _getItems.apply(this, arguments);
      }

      return getItems;
    }()
  }, {
    key: "getItemsMapped",
    value: function () {
      var _getItemsMapped = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var ids, data, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getExistIds();

              case 2:
                ids = _context3.sent;
                _context3.next = 5;
                return this.getItems(ids);

              case 5:
                data = _context3.sent;

                if (!(ids.length != data.length)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", Promise.reject('missing id to item mapping'));

              case 8:
                result = {};
                ids.forEach(function (id, index) {
                  return result[id] = data[index];
                });
                return _context3.abrupt("return", result);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getItemsMapped() {
        return _getItemsMapped.apply(this, arguments);
      }

      return getItemsMapped;
    }()
  }, {
    key: "getExistIds",
    value: function () {
      var _getExistIds = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.contract.getExistIds();

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result.map(function (it) {
                  return it.toNumber();
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getExistIds() {
        return _getExistIds.apply(this, arguments);
      }

      return getExistIds;
    }()
  }, {
    key: "setItems",
    value: function () {
      var _setItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(items) {
        var tx;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.contract.setItems(items);

              case 2:
                tx = _context5.sent;
                _context5.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setItems(_x3) {
        return _setItems.apply(this, arguments);
      }

      return setItems;
    }()
  }, {
    key: "removeItems",
    value: function () {
      var _removeItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(ids) {
        var tx;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                ids.forEach(function (id) {
                  return Uint.validate(id);
                });
                _context6.next = 3;
                return this.contract.removeItems(ids);

              case 3:
                tx = _context6.sent;
                _context6.next = 6;
                return tx.wait(this.confirmBlocks);

              case 6:
                return _context6.abrupt("return", _context6.sent);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function removeItems(_x4) {
        return _removeItems.apply(this, arguments);
      }

      return removeItems;
    }()
    /** Management **/

  }, {
    key: "setPaymentToken",
    value: function () {
      var _setPaymentToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(tokenAddress) {
        var tx;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.contract.setPaymentToken(tokenAddress);

              case 2:
                tx = _context7.sent;
                _context7.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context7.abrupt("return", _context7.sent);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setPaymentToken(_x5) {
        return _setPaymentToken.apply(this, arguments);
      }

      return setPaymentToken;
    }()
  }, {
    key: "pause",
    value: function () {
      var _pause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var tx;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.contract.pause();

              case 2:
                tx = _context8.sent;
                _context8.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context8.abrupt("return", _context8.sent);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function pause() {
        return _pause.apply(this, arguments);
      }

      return pause;
    }()
  }, {
    key: "unpause",
    value: function () {
      var _unpause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var tx;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.contract.unpause();

              case 2:
                tx = _context9.sent;
                _context9.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context9.abrupt("return", _context9.sent);

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function unpause() {
        return _unpause.apply(this, arguments);
      }

      return unpause;
    }()
    /** Purchase */

  }, {
    key: "hasSupply",
    value: function () {
      var _hasSupply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(itemId, quantity) {
        var item;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                Uint.validate(itemId);
                _context10.next = 3;
                return this.getItem(itemId);

              case 3:
                item = _context10.sent;
                return _context10.abrupt("return", this.itemHasSupply(item, quantity));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function hasSupply(_x6, _x7) {
        return _hasSupply.apply(this, arguments);
      }

      return hasSupply;
    }()
  }, {
    key: "itemHasSupply",
    value: function () {
      var _itemHasSupply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(item, quantity) {
        var numSold;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.assets.modelMinted(item.modelId);

              case 2:
                numSold = _context11.sent;
                return _context11.abrupt("return", numSold.add(quantity).lte(item.maxSupply));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function itemHasSupply(_x8, _x9) {
        return _itemHasSupply.apply(this, arguments);
      }

      return itemHasSupply;
    }()
  }, {
    key: "preOrder",
    value: function () {
      var _preOrder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(modelId, quantity, statusEvent) {
        var item, caller, preOrderLimit, preOrderConsumed, tx;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                Uint.validate(modelId);
                _context12.next = 3;
                return this.getItem(modelId);

              case 3:
                item = _context12.sent;
                _context12.next = 6;
                return this.signer.getAddress();

              case 6:
                caller = _context12.sent;
                _context12.next = 9;
                return this.getPreOrderLimit(caller, modelId);

              case 9:
                preOrderLimit = _context12.sent;
                _context12.next = 12;
                return this.getPreOrderConsumed(caller, modelId);

              case 12:
                preOrderConsumed = _context12.sent;

                if (!preOrderConsumed.add(quantity).gt(preOrderLimit)) {
                  _context12.next = 15;
                  break;
                }

                return _context12.abrupt("return", Promise.reject(ErrorType.PreOrder_NoSupply));

              case 15:
                _context12.next = 17;
                return this.itemHasSupply(item, quantity);

              case 17:
                if (_context12.sent) {
                  _context12.next = 19;
                  break;
                }

                return _context12.abrupt("return", Promise.reject(ErrorType.Token_NoSupply));

              case 19:
                _context12.next = 21;
                return this.hasBalanceFor(caller, item.price.mul(quantity));

              case 21:
                if (_context12.sent) {
                  _context12.next = 23;
                  break;
                }

                return _context12.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientBalance));

              case 23:
                _context12.next = 25;
                return this.adjustAllowance(item.price.mul(quantity));

              case 25:
                if (_context12.sent) {
                  _context12.next = 27;
                  break;
                }

                return _context12.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientAllowance));

              case 27:
                execute(statusEvent, BuyStatus.REQUIREMENT_SUCCESS);
                _context12.next = 30;
                return this.contract.preorder(modelId, quantity);

              case 30:
                tx = _context12.sent;
                execute(statusEvent, BuyStatus.PUBLISH_BUY);
                _context12.next = 34;
                return tx.wait(this.confirmBlocks);

              case 34:
                return _context12.abrupt("return", _context12.sent);

              case 35:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function preOrder(_x10, _x11, _x12) {
        return _preOrder.apply(this, arguments);
      }

      return preOrder;
    }()
  }, {
    key: "buy",
    value: function () {
      var _buy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(modelId, quantity, statusEvent) {
        var item, caller, tx;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                Uint.validate(modelId);
                _context13.next = 3;
                return this.getItem(modelId);

              case 3:
                item = _context13.sent;
                _context13.next = 6;
                return this.signer.getAddress();

              case 6:
                caller = _context13.sent;
                _context13.next = 9;
                return this.itemHasSupply(item, quantity);

              case 9:
                if (_context13.sent) {
                  _context13.next = 11;
                  break;
                }

                return _context13.abrupt("return", Promise.reject(ErrorType.Token_NoSupply));

              case 11:
                _context13.next = 13;
                return this.hasBalanceFor(caller, item.price.mul(quantity));

              case 13:
                if (_context13.sent) {
                  _context13.next = 15;
                  break;
                }

                return _context13.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientBalance));

              case 15:
                _context13.next = 17;
                return this.adjustAllowance(item.price.mul(quantity));

              case 17:
                if (_context13.sent) {
                  _context13.next = 19;
                  break;
                }

                return _context13.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientAllowance));

              case 19:
                execute(statusEvent, BuyStatus.REQUIREMENT_SUCCESS);
                _context13.next = 22;
                return this.contract.buy(modelId, quantity);

              case 22:
                tx = _context13.sent;
                execute(statusEvent, BuyStatus.PUBLISH_BUY);
                _context13.next = 26;
                return tx.wait(this.confirmBlocks);

              case 26:
                return _context13.abrupt("return", _context13.sent);

              case 27:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function buy(_x13, _x14, _x15) {
        return _buy.apply(this, arguments);
      }

      return buy;
    }()
    /** Pre-sale */

  }, {
    key: "airDrop",
    value: function () {
      var _airDrop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(receivers) {
        var tx;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.contract.airDrop(receivers);

              case 2:
                tx = _context14.sent;
                _context14.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context14.abrupt("return", _context14.sent);

              case 6:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function airDrop(_x16) {
        return _airDrop.apply(this, arguments);
      }

      return airDrop;
    }()
  }, {
    key: "rawAirDrop",
    value: function () {
      var _rawAirDrop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(receivers, privateKey, gas, alchemy) {
        var maxPerTx, provider, wallet, rawContract, generateTx, calcGas, _calcGas, transactions, totalNFT, transactionHashes, index, gasEstimated, _gas, tx, response, todo, pending, csv;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _calcGas = function _calcGas3() {
                  _calcGas = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(gasEstimated) {
                    var result, _yield$axios$get, data, maxFeePerGas, maxPriorityFeePerGas;

                    return regeneratorRuntime.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            result = {
                              gasLimit: gasEstimated.mul(110).div(100),
                              maxFeePerGas: isNotNull(gas.maxFeePerGas) ? ethers.utils.parseUnits(gas.maxFeePerGas.toString(), 'gwei') : ethers.utils.parseUnits("40", 'gwei'),
                              maxPriorityFeePerGas: isNotNull(gas.maxPriorityFeePerGas) ? ethers.utils.parseUnits(gas.maxFeePerGas.toString(), 'gwei') : ethers.utils.parseUnits("40", 'gwei')
                            };
                            _context15.prev = 1;

                            if (!isNull(alchemy.gasStation)) {
                              _context15.next = 4;
                              break;
                            }

                            return _context15.abrupt("return", result);

                          case 4:
                            _context15.next = 6;
                            return axios.get(alchemy.gasStation);

                          case 6:
                            _yield$axios$get = _context15.sent;
                            data = _yield$axios$get.data;
                            maxFeePerGas = ethers.utils.parseUnits(data.fast.maxFee.toString(), 'gwei');
                            maxPriorityFeePerGas = ethers.utils.parseUnits(data.fast.maxPriorityFee.toString(), 'gwei');

                            if (result.maxFeePerGas < maxFeePerGas) {
                              result.maxFeePerGas = maxFeePerGas;
                            }

                            if (result.maxPriorityFeePerGas < maxPriorityFeePerGas) {
                              result.maxPriorityFeePerGas = maxPriorityFeePerGas;
                            }

                            _context15.next = 16;
                            break;

                          case 14:
                            _context15.prev = 14;
                            _context15.t0 = _context15["catch"](1);

                          case 16:
                            return _context15.abrupt("return", result);

                          case 17:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15, null, [[1, 14]]);
                  }));
                  return _calcGas.apply(this, arguments);
                };

                calcGas = function _calcGas2(_x21) {
                  return _calcGas.apply(this, arguments);
                };

                generateTx = function _generateTx(receivers) {
                  var max = BigNumber.from(maxPerTx);
                  var transactions = [];
                  var current = BigNumber.from(0);
                  var index = 0;
                  receivers.forEach(function (value) {
                    var amount = BigNumber.from(value.amount);

                    if (!current.eq(0) && amount.add(current).gt(max)) {
                      transactions[index].push({
                        receiver: value.receiver,
                        modelId: value.modelId,
                        amount: max.sub(current)
                      });
                      amount = amount.sub(max.sub(current));
                      current = BigNumber.from(0);
                      ++index;
                    }

                    while (amount.gt(max)) {
                      transactions[index] = [{
                        receiver: value.receiver,
                        modelId: value.modelId,
                        amount: max
                      }];
                      amount = amount.sub(max);
                      current = BigNumber.from(0);
                      ++index;
                    }

                    if (amount.gt(0)) {
                      if (transactions[index] == undefined) {
                        transactions[index] = [];
                      }

                      transactions[index].push({
                        receiver: value.receiver,
                        modelId: value.modelId,
                        amount: amount
                      });
                      current = current.add(amount);
                    }

                    if (current.eq(max)) {
                      current = BigNumber.from(0);
                      ++index;
                    }
                  });
                  return transactions;
                };

                throwIfNull(alchemy.apiKey, "Missing Alchemy apiKey.");
                throwIfNull(alchemy.network, "Missing Alchemy network.");
                throwIfNull(alchemy.chainId, "Missing Alchemy chainId."); // const alchemySDK = new Alchemy({
                //     apiKey: alchemy.apiKey!,
                //     network: alchemy.network!
                // })

                maxPerTx = 50;
                provider = ethers.getDefaultProvider(alchemy.network, {
                  alchemy: alchemy.apiKey
                });
                wallet = new Wallet(privateKey, provider);
                rawContract = new ethers.Contract(this.contractAddress, this.abi, wallet);
                transactions = generateTx(receivers);
                totalNFT = transactions.flatMap(function (it) {
                  return it.map(function (tx) {
                    return tx.amount;
                  });
                }).reduce(function (a, b) {
                  return a.add(b);
                }, BigNumber.from(0));
                console.log("### Airdrop script:");
                console.log("### contract: ", this.contractAddress);
                console.log("### transactions: ", transactions.map(function (it) {
                  return it.map(function (tx) {
                    return {
                      receiver: tx.receiver,
                      modelId: tx.modelId,
                      amount: tx.amount.toString()
                    };
                  });
                }));
                console.log("### ".concat(totalNFT, " NFT in ").concat(transactions.length, " transactions"));
                transactionHashes = [];
                index = 0;

              case 18:
                if (!(index < transactions.length)) {
                  _context16.next = 44;
                  break;
                }

                _context16.prev = 19;
                _context16.next = 22;
                return rawContract.estimateGas.airDrop(transactions[index]);

              case 22:
                gasEstimated = _context16.sent;
                _context16.next = 25;
                return calcGas(gasEstimated);

              case 25:
                _gas = _context16.sent;
                console.log("# [".concat(index, "] gas:"), _gas.gasLimit.toString(), _gas.maxFeePerGas.toString(), _gas.maxPriorityFeePerGas.toString());
                _context16.next = 29;
                return rawContract.airDrop(transactions[index], _gas);

              case 29:
                tx = _context16.sent;
                _context16.next = 32;
                return tx.wait(this.confirmBlocks);

              case 32:
                response = _context16.sent;
                console.log("# [".concat(index, "]: Done [block:").concat(response.blockHash, ", transaction:").concat(response.transactionHash, ", gas:").concat(response.gasUsed.toString(), "]"));
                transactionHashes.push("[".concat(index, "] ").concat(response.transactionHash));
                _context16.next = 41;
                break;

              case 37:
                _context16.prev = 37;
                _context16.t0 = _context16["catch"](19);
                console.log("# [".concat(index, "]: Failed"), _context16.t0);
                return _context16.abrupt("break", 44);

              case 41:
                index++;
                _context16.next = 18;
                break;

              case 44:
                todo = "";

                if (index < transactions.length) {
                  console.log("### Airdrop : failed from index [".concat(index, "], please restart from there."));
                  pending = transactions.slice(index);
                  csv = [];
                  pending.forEach(function (tx) {
                    tx.forEach(function (it) {
                      csv.push("".concat(it.receiver, ",").concat(it.modelId, ",").concat(it.amount.toString()));
                    });
                  });
                  todo = csv.join(",\r\n");
                } else {
                  console.log("### Airdrop : completed");
                }

                return _context16.abrupt("return", {
                  "completed": transactionHashes,
                  "todo": todo
                });

              case 47:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[19, 37]]);
      }));

      function rawAirDrop(_x17, _x18, _x19, _x20) {
        return _rawAirDrop.apply(this, arguments);
      }

      return rawAirDrop;
    }()
  }, {
    key: "setPreorderLimits",
    value: function () {
      var _setPreorderLimits = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(limits) {
        var addresses, modelIds, amounts;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                addresses = [];
                modelIds = [];
                amounts = [];
                limits.forEach(function (limit) {
                  addresses.push(limit.address);
                  modelIds.push(limit.modelId);
                  amounts.push(limit.amount);
                });
                _context17.next = 6;
                return this.setPreorderLimitsFlat(addresses, modelIds, amounts);

              case 6:
                return _context17.abrupt("return", _context17.sent);

              case 7:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function setPreorderLimits(_x22) {
        return _setPreorderLimits.apply(this, arguments);
      }

      return setPreorderLimits;
    }()
  }, {
    key: "setPreorderLimitsFlat",
    value: function () {
      var _setPreorderLimitsFlat = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(addresses, modelIds, amounts) {
        var tx;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                Uint.validateAll(modelIds);
                Uint.validateAll(amounts);
                _context18.next = 4;
                return this.contract.setPreorderLimits(addresses, modelIds, amounts);

              case 4:
                tx = _context18.sent;
                _context18.next = 7;
                return tx.wait(this.confirmBlocks);

              case 7:
                return _context18.abrupt("return", _context18.sent);

              case 8:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function setPreorderLimitsFlat(_x23, _x24, _x25) {
        return _setPreorderLimitsFlat.apply(this, arguments);
      }

      return setPreorderLimitsFlat;
    }()
  }, {
    key: "getPreOrderLimit",
    value: function () {
      var _getPreOrderLimit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(account, tokenId) {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                Uint.validate(tokenId);
                _context19.t0 = BigNumber;
                _context19.next = 4;
                return this.contract.preorderLimits(tokenId, account);

              case 4:
                _context19.t1 = _context19.sent;
                return _context19.abrupt("return", _context19.t0.from.call(_context19.t0, _context19.t1));

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getPreOrderLimit(_x26, _x27) {
        return _getPreOrderLimit.apply(this, arguments);
      }

      return getPreOrderLimit;
    }()
  }, {
    key: "getPreOrderConsumed",
    value: function () {
      var _getPreOrderConsumed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(account, tokenId) {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                Uint.validate(tokenId);
                _context20.t0 = BigNumber;
                _context20.next = 4;
                return this.contract.numPreorders(tokenId, account);

              case 4:
                _context20.t1 = _context20.sent;
                return _context20.abrupt("return", _context20.t0.from.call(_context20.t0, _context20.t1));

              case 6:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getPreOrderConsumed(_x28, _x29) {
        return _getPreOrderConsumed.apply(this, arguments);
      }

      return getPreOrderConsumed;
    }()
    /** Accounting */

  }, {
    key: "balance",
    value: function () {
      var _balance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.t0 = BigNumber;
                _context21.next = 3;
                return this.balanceOf(this.contractAddress);

              case 3:
                _context21.t1 = _context21.sent;
                return _context21.abrupt("return", _context21.t0.from.call(_context21.t0, _context21.t1));

              case 5:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function balance() {
        return _balance.apply(this, arguments);
      }

      return balance;
    }()
  }, {
    key: "withdrawToken",
    value: function () {
      var _withdrawToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(to, amount) {
        var tx;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.contract.withdrawToken(to, amount);

              case 2:
                tx = _context22.sent;
                _context22.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context22.abrupt("return", _context22.sent);

              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function withdrawToken(_x30, _x31) {
        return _withdrawToken.apply(this, arguments);
      }

      return withdrawToken;
    }()
    /** Role */

  }, {
    key: "setAsMaintainer",
    value: function () {
      var _setAsMaintainer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(maintainer) {
        var role;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                role = keccak256(toUtf8Bytes('MAINTAINER_ROLE'));
                _context23.next = 3;
                return this.grantRole(role, maintainer);

              case 3:
                return _context23.abrupt("return", _context23.sent);

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function setAsMaintainer(_x32) {
        return _setAsMaintainer.apply(this, arguments);
      }

      return setAsMaintainer;
    }()
  }, {
    key: "removeMaintainRole",
    value: function () {
      var _removeMaintainRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(maintainer) {
        var role;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                role = keccak256(toUtf8Bytes('MAINTAINER_ROLE'));
                _context24.next = 3;
                return this.revokeRole(role, maintainer);

              case 3:
                return _context24.abrupt("return", _context24.sent);

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function removeMaintainRole(_x33) {
        return _removeMaintainRole.apply(this, arguments);
      }

      return removeMaintainRole;
    }()
  }, {
    key: "grantRole",
    value: function () {
      var _grantRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this.contract.grantRole(role, account);

              case 2:
                tx = _context25.sent;
                _context25.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context25.abrupt("return", _context25.sent);

              case 6:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function grantRole(_x34, _x35) {
        return _grantRole.apply(this, arguments);
      }

      return grantRole;
    }()
  }, {
    key: "revokeRole",
    value: function () {
      var _revokeRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.contract.revokeRole(role, account);

              case 2:
                tx = _context26.sent;
                _context26.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context26.abrupt("return", _context26.sent);

              case 6:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function revokeRole(_x36, _x37) {
        return _revokeRole.apply(this, arguments);
      }

      return revokeRole;
    }()
  }, {
    key: "hasRole",
    value: function () {
      var _hasRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(role, account) {
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.contract.hasRole(role, account);

              case 2:
                return _context27.abrupt("return", _context27.sent);

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function hasRole(_x38, _x39) {
        return _hasRole.apply(this, arguments);
      }

      return hasRole;
    }()
  }, {
    key: "gotRole",
    value: function () {
      var _gotRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(role) {
        var caller;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context28.sent;
                _context28.next = 5;
                return this.hasRole(role, caller);

              case 5:
                return _context28.abrupt("return", _context28.sent);

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function gotRole(_x40) {
        return _gotRole.apply(this, arguments);
      }

      return gotRole;
    }()
    /** 3rd PaymentToken interaction */

  }, {
    key: "balanceOf",
    value: function () {
      var _balanceOf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(address) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context29.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context29.next = 6;
                return paymentToken.balanceOf(address);

              case 6:
                return _context29.abrupt("return", _context29.sent);

              case 7:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function balanceOf(_x41) {
        return _balanceOf.apply(this, arguments);
      }

      return balanceOf;
    }()
  }, {
    key: "hasBalanceFor",
    value: function () {
      var _hasBalanceFor = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(caller, amount) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context30.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context30.next = 6;
                return paymentToken.hasBalanceFor(caller, amount);

              case 6:
                return _context30.abrupt("return", _context30.sent);

              case 7:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function hasBalanceFor(_x42, _x43) {
        return _hasBalanceFor.apply(this, arguments);
      }

      return hasBalanceFor;
    }()
  }, {
    key: "adjustAllowance",
    value: function () {
      var _adjustAllowance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31(amount) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context31.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context31.next = 6;
                return paymentToken.adjustAllowance(this.contractAddress, amount);

              case 6:
                return _context31.abrupt("return", _context31.sent);

              case 7:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function adjustAllowance(_x44) {
        return _adjustAllowance.apply(this, arguments);
      }

      return adjustAllowance;
    }()
  }]);

  return StoreSDK;
}(ContractSDK);

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var DepositStatus;

(function (DepositStatus) {
  DepositStatus[DepositStatus["REQUIREMENT_SUCCESS"] = 0] = "REQUIREMENT_SUCCESS";
  DepositStatus[DepositStatus["PUBLISH_DEPOSIT"] = 1] = "PUBLISH_DEPOSIT";
})(DepositStatus || (DepositStatus = {}));

var TeleportSDK = /*#__PURE__*/function (_ContractSDK) {
  _inherits(TeleportSDK, _ContractSDK);

  var _super = _createSuper(TeleportSDK);

  function TeleportSDK(signer, contractAddress) {
    _classCallCheck(this, TeleportSDK);

    return _super.call(this, signer, contractAddress, TeleportAbi);
  }

  _createClass(TeleportSDK, [{
    key: "requestApproval",
    value: function () {
      var _requestApproval = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(NFTContractAddress) {
        var erc721;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                erc721 = new Erc721SDK(this.signer, NFTContractAddress, Erc721Abi);
                _context.next = 3;
                return erc721.setApprovalForAll(this.contract.address, true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requestApproval(_x) {
        return _requestApproval.apply(this, arguments);
      }

      return requestApproval;
    }()
  }, {
    key: "checkOwnership",
    value: function () {
      var _checkOwnership = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(NFTContractAddress, tokenId) {
        var erc721, caller, owner;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                erc721 = new Erc721SDK(this.signer, NFTContractAddress, Erc721Abi);
                _context2.next = 3;
                return this.signer.getAddress();

              case 3:
                caller = _context2.sent;
                _context2.next = 6;
                return erc721.ownerOf(tokenId);

              case 6:
                owner = _context2.sent;
                return _context2.abrupt("return", caller === owner);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function checkOwnership(_x2, _x3) {
        return _checkOwnership.apply(this, arguments);
      }

      return checkOwnership;
    }()
  }, {
    key: "depositBatch",
    value: function () {
      var _depositBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(NFTContractAddress, tokenIds, statusEvent) {
        var _iterator, _step, tokenId, tx;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.requestApproval(NFTContractAddress);

              case 2:
                _iterator = _createForOfIteratorHelper(tokenIds);
                _context3.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context3.next = 13;
                  break;
                }

                tokenId = _step.value;
                _context3.next = 9;
                return this.checkOwnership(NFTContractAddress, tokenId);

              case 9:
                if (_context3.sent) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return", Promise.reject(ErrorType.Token_NotOwned));

              case 11:
                _context3.next = 5;
                break;

              case 13:
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](3);

                _iterator.e(_context3.t0);

              case 18:
                _context3.prev = 18;

                _iterator.f();

                return _context3.finish(18);

              case 21:
                execute(statusEvent, DepositStatus.REQUIREMENT_SUCCESS);
                _context3.next = 24;
                return this.contract.depositBatch(NFTContractAddress, tokenIds);

              case 24:
                tx = _context3.sent;
                execute(statusEvent, DepositStatus.PUBLISH_DEPOSIT);
                _context3.next = 28;
                return tx.wait(this.confirmBlocks);

              case 28:
                return _context3.abrupt("return", _context3.sent);

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 15, 18, 21]]);
      }));

      function depositBatch(_x4, _x5, _x6) {
        return _depositBatch.apply(this, arguments);
      }

      return depositBatch;
    }()
  }, {
    key: "withdrawBatch",
    value: function () {
      var _withdrawBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(NFTContractAddress, tokenIds, receivers, requestUuid) {
        var tx;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.contract.withdrawBatch(NFTContractAddress, tokenIds, receivers, requestUuid);

              case 2:
                tx = _context4.sent;
                _context4.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function withdrawBatch(_x7, _x8, _x9, _x10) {
        return _withdrawBatch.apply(this, arguments);
      }

      return withdrawBatch;
    }()
  }]);

  return TeleportSDK;
}(ContractSDK);

var DMASDK = /*#__PURE__*/function (_ContractSDK) {
  _inherits(DMASDK, _ContractSDK);

  var _super = _createSuper(DMASDK);

  function DMASDK(signer, contractAddress) {
    var _this;

    _classCallCheck(this, DMASDK);

    _this = _super.call(this, signer, contractAddress, DMAAbi);

    _defineProperty(_assertThisInitialized(_this), "withdrawAddressMainnet", "0x0bea5431aba22566c14e4da8cdd6e3a8d6581a1e");

    _defineProperty(_assertThisInitialized(_this), "withdrawAddressTestnet", "0xB95015B177438BFD43B5CD6Fe18E293BB9770B75");

    _defineProperty(_assertThisInitialized(_this), "usdcDecimals", BigNumber.from(1000000));

    return _this;
  }

  _createClass(DMASDK, [{
    key: "adjustAllowance",
    value: function () {
      var _adjustAllowance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(amount) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context.next = 6;
                return paymentToken.adjustAllowance(this.contractAddress, amount);

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function adjustAllowance(_x) {
        return _adjustAllowance.apply(this, arguments);
      }

      return adjustAllowance;
    }()
  }, {
    key: "hasBalanceFor",
    value: function () {
      var _hasBalanceFor = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(caller, amount) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context2.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context2.next = 6;
                return paymentToken.hasBalanceFor(caller, amount);

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function hasBalanceFor(_x2, _x3) {
        return _hasBalanceFor.apply(this, arguments);
      }

      return hasBalanceFor;
    }()
  }, {
    key: "dmaHasSupply",
    value: function () {
      var _dmaHasSupply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(quantity) {
        var maxSupply, numSold;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.contract.saleInfo();

              case 2:
                maxSupply = _context3.sent.maxSupply;
                _context3.next = 5;
                return this.contract.numSold();

              case 5:
                numSold = _context3.sent;
                return _context3.abrupt("return", numSold.add(quantity).lte(maxSupply));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function dmaHasSupply(_x4) {
        return _dmaHasSupply.apply(this, arguments);
      }

      return dmaHasSupply;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(initPaymentToken, maxSupply, price, priceIncreaseFrom, priceIncreaseInterval, priceIncreaseValue) {
        var tx;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.contract.initialize(initPaymentToken, {
                  maxSupply: maxSupply,
                  price: price,
                  priceIncreaseFrom: priceIncreaseFrom,
                  priceIncreaseInterval: priceIncreaseInterval,
                  priceIncreaseValue: priceIncreaseValue
                });

              case 2:
                tx = _context4.sent;
                _context4.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function initialize(_x5, _x6, _x7, _x8, _x9, _x10) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "balanceOf",
    value: function () {
      var _balanceOf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(address) {
        var tokenAddress, paymentToken;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.contract.paymentToken();

              case 2:
                tokenAddress = _context5.sent;
                paymentToken = new Erc20SDK(this.signer, tokenAddress);
                _context5.next = 6;
                return paymentToken.balanceOf(address);

              case 6:
                return _context5.abrupt("return", _context5.sent);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function balanceOf(_x11) {
        return _balanceOf.apply(this, arguments);
      }

      return balanceOf;
    }()
    /** Accounting */

  }, {
    key: "balance",
    value: function () {
      var _balance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.t0 = BigNumber;
                _context6.next = 3;
                return this.balanceOf(this.contractAddress);

              case 3:
                _context6.t1 = _context6.sent;
                return _context6.abrupt("return", _context6.t0.from.call(_context6.t0, _context6.t1));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function balance() {
        return _balance.apply(this, arguments);
      }

      return balance;
    }()
  }, {
    key: "showBalance",
    value: function () {
      var _showBalance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var balance;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.balanceOf(this.contractAddress);

              case 2:
                balance = _context7.sent;
                return _context7.abrupt("return", "".concat(balance.div(this.usdcDecimals), " USDC"));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function showBalance() {
        return _showBalance.apply(this, arguments);
      }

      return showBalance;
    }()
  }, {
    key: "withdrawToken",
    value: function () {
      var _withdrawToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(amount) {
        var amountToSend, withdrawTo, tx;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                amountToSend = BigNumber.from(amount).mul(this.usdcDecimals);
                _context8.next = 3;
                return this.getWithdrawAddress();

              case 3:
                withdrawTo = _context8.sent;
                _context8.next = 6;
                return this.contract.withdrawToken(withdrawTo, amountToSend);

              case 6:
                tx = _context8.sent;
                _context8.next = 9;
                return tx.wait(this.confirmBlocks);

              case 9:
                return _context8.abrupt("return", _context8.sent);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function withdrawToken(_x12) {
        return _withdrawToken.apply(this, arguments);
      }

      return withdrawToken;
    }()
  }, {
    key: "getWithdrawAddress",
    value: function () {
      var _getWithdrawAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var chainId;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.signer.getChainId();

              case 2:
                chainId = _context9.sent;
                return _context9.abrupt("return", chainId == 5 ? this.withdrawAddressTestnet : this.withdrawAddressMainnet);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getWithdrawAddress() {
        return _getWithdrawAddress.apply(this, arguments);
      }

      return getWithdrawAddress;
    }()
    /** Managing */

  }, {
    key: "airDrop",
    value: function () {
      var _airDrop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(accountUUIDs, amounts) {
        var accountHexes, tx;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                throwIf(accountUUIDs.length !== amounts.length, "Invalid uuids & amounts association.");
                accountHexes = accountUUIDs.map(function (uuid) {
                  return uuidToHex(uuid, true);
                });
                _context10.next = 4;
                return this.contract.airdrop(accountHexes, amounts);

              case 4:
                tx = _context10.sent;
                _context10.next = 7;
                return tx.wait(this.confirmBlocks);

              case 7:
                return _context10.abrupt("return", _context10.sent);

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function airDrop(_x13, _x14) {
        return _airDrop.apply(this, arguments);
      }

      return airDrop;
    }()
  }, {
    key: "airDropByEmail",
    value: function () {
      var _airDropByEmail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(accountEmails, amounts, sso) {
        var client, response, accountUuids;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                throwIfNull(sso.jwt, "Missing SSO authentication.");
                throwIfNull(sso.domain, "Missing SSO Domain.");
                client = new Client(sso.domain, false);
                _context11.next = 5;
                return client.user.all(authQuery({
                  emails: accountEmails,
                  userIds: undefined,
                  userUuids: undefined,
                  registeredAfter: null,
                  registeredBefore: null
                }, Auth.token(sso.jwt)));

              case 5:
                response = _context11.sent;
                accountUuids = accountEmails.map(function (email) {
                  var user = response.users.find(function (it) {
                    return it.email === email;
                  });

                  if (user == null) {
                    throw Error("User not found for email [".concat(email, "]"));
                  }

                  return user.identifier;
                });
                return _context11.abrupt("return", this.airDrop(accountUuids, amounts));

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function airDropByEmail(_x15, _x16, _x17) {
        return _airDropByEmail.apply(this, arguments);
      }

      return airDropByEmail;
    }()
  }, {
    key: "setSaleInfo",
    value: function () {
      var _setSaleInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(info) {
        var tx;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.contract.setSaleInfo(info);

              case 2:
                tx = _context12.sent;
                _context12.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context12.abrupt("return", _context12.sent);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function setSaleInfo(_x18) {
        return _setSaleInfo.apply(this, arguments);
      }

      return setSaleInfo;
    }()
  }, {
    key: "increaseNumSold",
    value: function () {
      var _increaseNumSold = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(value) {
        var tx;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.contract.increaseNumSold(value);

              case 2:
                tx = _context13.sent;
                _context13.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context13.abrupt("return", _context13.sent);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function increaseNumSold(_x19) {
        return _increaseNumSold.apply(this, arguments);
      }

      return increaseNumSold;
    }()
  }, {
    key: "grantRole",
    value: function () {
      var _grantRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.contract.grantRole(role, account);

              case 2:
                tx = _context14.sent;
                _context14.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context14.abrupt("return", _context14.sent);

              case 6:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function grantRole(_x20, _x21) {
        return _grantRole.apply(this, arguments);
      }

      return grantRole;
    }()
  }, {
    key: "revokeRole",
    value: function () {
      var _revokeRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.contract.revokeRole(role, account);

              case 2:
                tx = _context15.sent;
                _context15.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context15.abrupt("return", _context15.sent);

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function revokeRole(_x22, _x23) {
        return _revokeRole.apply(this, arguments);
      }

      return revokeRole;
    }()
  }, {
    key: "hasRole",
    value: function () {
      var _hasRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(role, account) {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.contract.hasRole(role, account);

              case 2:
                return _context16.abrupt("return", _context16.sent);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function hasRole(_x24, _x25) {
        return _hasRole.apply(this, arguments);
      }

      return hasRole;
    }()
  }, {
    key: "gotRole",
    value: function () {
      var _gotRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(role) {
        var caller;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context17.sent;
                _context17.next = 5;
                return this.hasRole(role, caller);

              case 5:
                return _context17.abrupt("return", _context17.sent);

              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function gotRole(_x26) {
        return _gotRole.apply(this, arguments);
      }

      return gotRole;
    }()
  }, {
    key: "buy",
    value: function () {
      var _buy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(accountUUID, amount, invitationCode, signature, statusEvent) {
        var caller, totalPrice, tx;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context18.sent;
                _context18.next = 5;
                return this.contract.saleInfo();

              case 5:
                totalPrice = _context18.sent.price.mul(amount);
                _context18.next = 8;
                return this.hasBalanceFor(caller, totalPrice);

              case 8:
                if (_context18.sent) {
                  _context18.next = 10;
                  break;
                }

                return _context18.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientBalance));

              case 10:
                _context18.next = 12;
                return this.adjustAllowance(totalPrice);

              case 12:
                if (_context18.sent) {
                  _context18.next = 14;
                  break;
                }

                return _context18.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientAllowance));

              case 14:
                _context18.next = 16;
                return this.dmaHasSupply(amount);

              case 16:
                if (_context18.sent) {
                  _context18.next = 18;
                  break;
                }

                return _context18.abrupt("return", Promise.reject(ErrorType.Token_NoSupply));

              case 18:
                execute(statusEvent, BuyStatus.REQUIREMENT_SUCCESS);
                _context18.next = 21;
                return this.contract.buy(accountUUID, amount, invitationCode, signature);

              case 21:
                tx = _context18.sent;
                execute(statusEvent, BuyStatus.PUBLISH_BUY);
                _context18.next = 25;
                return tx.wait(this.confirmBlocks);

              case 25:
                return _context18.abrupt("return", _context18.sent);

              case 26:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function buy(_x27, _x28, _x29, _x30, _x31) {
        return _buy.apply(this, arguments);
      }

      return buy;
    }()
  }]);

  return DMASDK;
}(ContractSDK);

var TokenWithdrawalSDK = /*#__PURE__*/function (_ContractSDK) {
  _inherits(TokenWithdrawalSDK, _ContractSDK);

  var _super = _createSuper(TokenWithdrawalSDK);

  function TokenWithdrawalSDK(signer, contractAddress) {
    _classCallCheck(this, TokenWithdrawalSDK);

    return _super.call(this, signer, contractAddress, TokenWithdrawalAbi);
  }

  _createClass(TokenWithdrawalSDK, [{
    key: "withdrawBySignature",
    value: function () {
      var _withdrawBySignature = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ERC20Address, toAddress, amount, accountUUID, requestUUID, signature) {
        var tx;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.contract.withdrawBySignature(ERC20Address, toAddress, amount, accountUUID, requestUUID, signature);

              case 2:
                tx = _context.sent;
                _context.next = 5;
                return tx.wait();

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function withdrawBySignature(_x, _x2, _x3, _x4, _x5, _x6) {
        return _withdrawBySignature.apply(this, arguments);
      }

      return withdrawBySignature;
    }()
  }, {
    key: "withdrawToken",
    value: function () {
      var _withdrawToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tokenAddress, amount) {
        var tx;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.contract.withdrawToken(tokenAddress, amount);

              case 2:
                tx = _context2.sent;
                _context2.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function withdrawToken(_x7, _x8) {
        return _withdrawToken.apply(this, arguments);
      }

      return withdrawToken;
    }()
  }, {
    key: "adjustAllowance",
    value: function () {
      var _adjustAllowance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(amount, erc20_address) {
        var paymentToken;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                paymentToken = new Erc20SDK(this.signer, erc20_address);
                _context3.next = 3;
                return paymentToken.adjustAllowance(this.contractAddress, amount);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function adjustAllowance(_x9, _x10) {
        return _adjustAllowance.apply(this, arguments);
      }

      return adjustAllowance;
    }()
  }, {
    key: "hasBalanceFor",
    value: function () {
      var _hasBalanceFor = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(caller, amount, erc20_address) {
        var paymentToken;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                paymentToken = new Erc20SDK(this.signer, erc20_address);
                _context4.next = 3;
                return paymentToken.hasBalanceFor(caller, amount);

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function hasBalanceFor(_x11, _x12, _x13) {
        return _hasBalanceFor.apply(this, arguments);
      }

      return hasBalanceFor;
    }()
  }, {
    key: "depositWithSignature",
    value: function () {
      var _depositWithSignature = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(tokenAddress, amount, toAccountUUID, requestUUID, data, signature) {
        var caller, tx;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context5.sent;
                _context5.next = 5;
                return this.hasBalanceFor(caller, amount, tokenAddress);

              case 5:
                if (_context5.sent) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientBalance));

              case 7:
                _context5.next = 9;
                return this.adjustAllowance(amount, tokenAddress);

              case 9:
                if (_context5.sent) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", Promise.reject(ErrorType.Wallet_InsufficientAllowance));

              case 11:
                _context5.next = 13;
                return this.contract.depositWithSignature(tokenAddress, amount, toAccountUUID, requestUUID, data, signature);

              case 13:
                tx = _context5.sent;
                _context5.next = 16;
                return tx.wait(this.confirmBlocks);

              case 16:
                return _context5.abrupt("return", _context5.sent);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function depositWithSignature(_x14, _x15, _x16, _x17, _x18, _x19) {
        return _depositWithSignature.apply(this, arguments);
      }

      return depositWithSignature;
    }()
  }, {
    key: "pause",
    value: function () {
      var _pause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var tx;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.contract.pause();

              case 2:
                tx = _context6.sent;
                _context6.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context6.abrupt("return", _context6.sent);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function pause() {
        return _pause.apply(this, arguments);
      }

      return pause;
    }()
  }, {
    key: "unpause",
    value: function () {
      var _unpause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var tx;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.contract.unpause();

              case 2:
                tx = _context7.sent;
                _context7.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context7.abrupt("return", _context7.sent);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function unpause() {
        return _unpause.apply(this, arguments);
      }

      return unpause;
    }()
  }, {
    key: "approveToken",
    value: function () {
      var _approveToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(tokenAddress, spender, amount) {
        var tx;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.contract.approveToken(tokenAddress, spender, amount);

              case 2:
                tx = _context8.sent;
                _context8.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context8.abrupt("return", _context8.sent);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function approveToken(_x20, _x21, _x22) {
        return _approveToken.apply(this, arguments);
      }

      return approveToken;
    }()
  }, {
    key: "blockRequest",
    value: function () {
      var _blockRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(requestUUID) {
        var tx;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.contract.blockRequest(requestUUID);

              case 2:
                tx = _context9.sent;
                _context9.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context9.abrupt("return", _context9.sent);

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function blockRequest(_x23) {
        return _blockRequest.apply(this, arguments);
      }

      return blockRequest;
    }()
  }, {
    key: "setWithdrawalRecipient",
    value: function () {
      var _setWithdrawalRecipient = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(withdrawRecipient) {
        var tx;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.contract.setWithdrawalRecipient(withdrawRecipient);

              case 2:
                tx = _context10.sent;
                _context10.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context10.abrupt("return", _context10.sent);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setWithdrawalRecipient(_x24) {
        return _setWithdrawalRecipient.apply(this, arguments);
      }

      return setWithdrawalRecipient;
    }()
  }, {
    key: "getWithdrawalRecipient",
    value: function () {
      var _getWithdrawalRecipient = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.contract.withdrawalRecipient();

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getWithdrawalRecipient() {
        return _getWithdrawalRecipient.apply(this, arguments);
      }

      return getWithdrawalRecipient;
    }()
  }, {
    key: "getTokenBalance",
    value: function () {
      var _getTokenBalance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(tokenAddress) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.contract.getTokenBalance(tokenAddress);

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getTokenBalance(_x25) {
        return _getTokenBalance.apply(this, arguments);
      }

      return getTokenBalance;
    }()
  }, {
    key: "grantRole",
    value: function () {
      var _grantRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.contract.grantRole(role, account);

              case 2:
                tx = _context13.sent;
                _context13.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context13.abrupt("return", _context13.sent);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function grantRole(_x26, _x27) {
        return _grantRole.apply(this, arguments);
      }

      return grantRole;
    }()
  }, {
    key: "revokeRole",
    value: function () {
      var _revokeRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(role, account) {
        var tx;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.contract.revokeRole(role, account);

              case 2:
                tx = _context14.sent;
                _context14.next = 5;
                return tx.wait(this.confirmBlocks);

              case 5:
                return _context14.abrupt("return", _context14.sent);

              case 6:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function revokeRole(_x28, _x29) {
        return _revokeRole.apply(this, arguments);
      }

      return revokeRole;
    }()
  }, {
    key: "hasRole",
    value: function () {
      var _hasRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(role, account) {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.contract.hasRole(role, account);

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function hasRole(_x30, _x31) {
        return _hasRole.apply(this, arguments);
      }

      return hasRole;
    }()
  }, {
    key: "gotRole",
    value: function () {
      var _gotRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(role) {
        var caller;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.signer.getAddress();

              case 2:
                caller = _context16.sent;
                _context16.next = 5;
                return this.hasRole(role, caller);

              case 5:
                return _context16.abrupt("return", _context16.sent);

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function gotRole(_x32) {
        return _gotRole.apply(this, arguments);
      }

      return gotRole;
    }()
  }]);

  return TokenWithdrawalSDK;
}(ContractSDK);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function stringify(data) {
  if (data === undefined || data === null) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map(function (item) {
      return stringify(item);
    });
  } else {
    var string = data.toString();

    if (string.startsWith("[object")) {
      var container = {};
      Object.keys(data).forEach(function (key) {
        container[key] = stringify(data[key]);
      });
      return container;
    } else {
      return string;
    }
  }
}

function method(v) {
  return _objectSpread2({
    name: v.method,
    description: undefined,
    restricted: [],
    parameters: [],
    formatResponse: stringify
  }, v);
}

var ParameterType;

(function (ParameterType) {
  ParameterType["String"] = "string";
  ParameterType["Address"] = "address";
  ParameterType["Integer"] = "integer";
  ParameterType["Float"] = "float";
  ParameterType["Boolean"] = "boolean";
  ParameterType["CSV"] = "csv";
  ParameterType["Timestamp"] = "timestamp";
  ParameterType["Object"] = "object";
  ParameterType["ArrayInt"] = "arrayInt";
  ParameterType["ArrayString"] = "arrayString";
  ParameterType["ArrayAddress"] = "arrayAddress";
})(ParameterType || (ParameterType = {}));

function string(name) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    name: name,
    type: ParameterType.String,
    description: description,
    hidden: hidden,
    value: value
  };
}
function address(name) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "e.g 0x1222..";
  var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    name: name,
    type: ParameterType.Address,
    description: description,
    hidden: hidden,
    value: value
  };
}
function object(name, attributes) {
  var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    name: name,
    type: ParameterType.Object,
    description: attributes,
    hidden: hidden,
    value: value
  };
}
function csv(name, columns) {
  var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    name: name,
    type: ParameterType.CSV,
    description: columns,
    hidden: hidden,
    value: undefined
  };
}
function bool(name) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "e.g 0 or 1";
  var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    name: name,
    type: ParameterType.Boolean,
    description: description,
    hidden: hidden,
    value: value
  };
}

function _int(name) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "e.g 16";
  var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    name: name,
    type: ParameterType.Integer,
    description: description,
    hidden: hidden,
    value: value
  };
}
function arrayInt(name) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "e.g 2,6,77,51";
  var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    name: name,
    type: ParameterType.ArrayInt,
    description: description,
    hidden: hidden,
    value: value
  };
}
function arrayString(name) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "e.g abc,etg,lkopp";
  var hidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    name: name,
    type: ParameterType.ArrayString,
    description: description,
    hidden: hidden,
    value: value
  };
}

var adminRole = {
  name: "DEFAULT_ADMIN_ROLE",
  role: "0x0000000000000000000000000000000000000000000000000000000000000000"
};
var AccessControlDoc = {
  title: "AccessControl SDK",
  description: undefined,
  contractName: undefined,
  roles: [adminRole],
  methodGroups: [{
    name: "Roles",
    description: "manage contract access",
    methods: [method({
      name: "Grant Role",
      method: "grantRole",
      parameters: [string("role", "role's code from smart-contract"), address("account")]
    }), method({
      name: "Revoke Role",
      method: "revokeRole",
      parameters: [string("role", "role's code from smart-contract"), address("account")]
    }), method({
      name: "User has Role",
      method: "hasRole",
      parameters: [string("role", "role's code from smart-contract"), address("account")]
    })]
  }],
  formatError: function formatError(errorType) {
    switch (errorType) {
      case ErrorType.Token_InsufficientBalance:
        return "Your Token balance is insufficient";

      default:
        return errorType.toString();
    }
  }
};

var Erc20Doc = {
  title: "ERC20 SDK",
  description: undefined,
  contractName: undefined,
  roles: [],
  methodGroups: [{
    name: "Balance",
    description: undefined,
    methods: [method({
      method: "balanceOf",
      parameters: [address("address")]
    }), method({
      method: "hasBalanceFor",
      parameters: [address("address"), _int("value")]
    })]
  }, {
    name: "Allowance",
    description: undefined,
    methods: [method({
      method: "allowance",
      parameters: [address("owner"), address("spender")]
    }), method({
      method: "adjust",
      parameters: [address("spender"), string("amount", "e.g 1000000")]
    }), method({
      method: "approve",
      parameters: [address("spender"), string("amount", "e.g 1000000")]
    }), method({
      method: "approveMaxAllowance",
      parameters: [address("spender")]
    })]
  }, {
    name: "Transfer",
    description: undefined,
    methods: [method({
      method: "transfer",
      parameters: [address("to"), string("amount", "e.g 1000")]
    }), method({
      method: "transferFrom",
      parameters: [address("from"), address("to"), string("amount", "e.g 1000")]
    })]
  }],
  formatError: function formatError(errorType) {
    switch (errorType) {
      case ErrorType.Token_InsufficientBalance:
        return "Your Token balance is insufficient";

      default:
        return errorType.toString();
    }
  }
};

var Erc1155Doc = {
  title: "ERC1155 SDK",
  description: undefined,
  contractName: undefined,
  roles: [],
  methodGroups: [{
    name: "Tokens",
    description: "manage tokens",
    methods: [method({
      method: "getTokenBalance",
      parameters: [_int("tokenId")]
    }), method({
      method: "getTokenBalanceOf",
      parameters: [address("user"), _int("tokenId")]
    }), method({
      method: "setTokenTransferApproval",
      parameters: [address("to"), bool("status")]
    }), method({
      method: "transferToken",
      parameters: [address("to"), _int("tokenId"), _int("quantity")]
    }), method({
      method: "transferTokenBatch",
      parameters: [address("to"), csv("tokens", "tokenId,quantity")]
    }), method({
      method: "transferTokenFrom",
      parameters: [address("from"), address("to"), _int("tokenId"), _int("quantity")]
    }), method({
      method: "transferTokenFromBatch",
      parameters: [address("from"), address("to"), csv("tokens", "tokenId,quantity")]
    })]
  }],
  formatError: function formatError(errorType) {
    switch (errorType) {
      case ErrorType.Token_InsufficientBalance:
        return "Your balance for this item is insufficient";

      default:
        return errorType.toString();
    }
  }
};

var Erc721Doc = {
  title: "ERC721 SDK",
  description: undefined,
  contractName: undefined,
  roles: [],
  methodGroups: [{
    name: "Tokens",
    description: "manage tokens",
    methods: [method({
      method: "balanceOf",
      parameters: [address("owner")]
    }), method({
      method: "ownerOf",
      parameters: [_int("tokenId")]
    })]
  }, {
    name: "Transfer",
    description: "transfer tokens to other user(s)",
    methods: [method({
      name: "Transfer token",
      description: "transfer your token to address",
      method: "safeTransfer",
      parameters: [address("to"), _int("tokenId")]
    }), method({
      name: "Transfer token from",
      method: "safeTransferFrom",
      description: "transfer token from one address to another",
      parameters: [address("from"), address("to"), _int("tokenId")]
    }), method({
      name: "Approve transfer",
      description: "allow third-user to transfer token to address",
      method: "approve",
      parameters: [address("to"), _int("tokenId")]
    }), method({
      name: "Approve all",
      description: "allow operator to do any operation on your tokens",
      method: "setApprovalForAll",
      parameters: [address("operator"), bool("approved")]
    }), method({
      name: "Approved on token",
      method: "getApproved",
      parameters: [_int("tokenId")]
    }), method({
      name: "Approved on account",
      method: "isApprovedForAll",
      parameters: [address("owner"), address("operator")]
    })]
  }],
  formatError: undefined
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function mergeMethods(a1) {
  var key = "name";
  var container = "methods";
  var result = a1;

  for (var _len = arguments.length, a2 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    a2[_key - 1] = arguments[_key];
  }

  a2.forEach(function (array) {
    array.forEach(function (item) {
      var index = result.findIndex(function (it) {
        return it[key] === item[key];
      });

      if (index !== -1) {
        var _result$index$contain;

        (_result$index$contain = result[index][container]).push.apply(_result$index$contain, _toConsumableArray(item[container]));

        result[index][container].sort(function (a, b) {
          return a[key].localeCompare(b[key]);
        });
      } else {
        result.push(item);
      }
    });
  });
  return result;
}
function unique(a1) {
  return _toConsumableArray(new Set(_toConsumableArray(a1)));
}

function roles() {
  for (var _len = arguments.length, roles = new Array(_len), _key = 0; _key < _len; _key++) {
    roles[_key] = arguments[_key];
  }

  return unique(roles);
}

var maintainRole$4 = {
  name: "MAINTAIN_ROLE",
  role: "0x0000000000000000000000000000000000000000000000000000000000000001"
};
var CollectiblesDoc = {
  title: "Delysium DelysiumCollectibles SDK",
  description: "Smart-contract SDK for collectibles non-unique tokens such as Posters and Badges",
  contractName: "collectibles",
  roles: roles.apply(void 0, [maintainRole$4].concat(_toConsumableArray(AccessControlDoc.roles), _toConsumableArray(Erc1155Doc.roles))),
  methodGroups: mergeMethods([{
    name: "Purchase",
    description: "Purchase NFTs",
    methods: [method({
      method: "hasSupply",
      parameters: [_int("tokenId"), _int("quantity")]
    }), method({
      method: "preOrder",
      description: "Only available during pre-public sale",
      parameters: [_int("tokenId"), _int("quantity")]
    }), method({
      method: "buy",
      parameters: [_int("tokenId"), _int("quantity")]
    })]
  }, {
    name: "Pre-sale",
    description: "manage whitelist and pre-sale",
    methods: [method({
      method: "airDrop",
      parameters: [csv("receivers", "receiver,tokenId,amount")],
      restricted: [maintainRole$4]
    }), method({
      method: "addToWhiteList",
      parameters: [csv("addresses", "receiver,tokenId,amount")],
      restricted: [maintainRole$4]
    }), method({
      method: "getPreOrderLimit",
      parameters: [address("account"), _int("tokenId")]
    }), method({
      method: "getPreOrderConsumed",
      parameters: [address("account"), _int("tokenId")]
    })]
  }, {
    name: "Tokens",
    description: "access NFTs",
    methods: [method({
      method: "getItemsMapped"
    }), method({
      method: "getItem",
      parameters: [_int("tokenId")]
    }), method({
      method: "getItems",
      parameters: [arrayInt("tokenIds")]
    }), method({
      method: "getItemAll"
    }), method({
      method: "setItems",
      parameters: [csv("items", "tokenId,maxSupply,price,metadataHash,timePreorderStart,timePreorderEnd,timeSaleStart,timeSaleEnd")],
      restricted: [maintainRole$4]
    }), method({
      method: "removeItems",
      parameters: [arrayInt("ids")],
      restricted: [maintainRole$4]
    })]
  }, {
    name: "Roles",
    description: "manage contract access",
    methods: [method({
      method: "addMaintainRole",
      parameters: [address("maintainer")]
    }), method({
      method: "removeMaintainRole",
      parameters: [address("maintainer")]
    })]
  }, {
    name: "Accounting",
    description: undefined,
    methods: [method({
      method: "balance"
    }), method({
      method: "withdrawToken",
      description: "ratio usdc/userInput: 1USDC = 1000000",
      parameters: [address("to"), string("amount", "e.g 40000000")],
      restricted: [adminRole]
    })]
  }, {
    name: "Management",
    description: undefined,
    methods: [method({
      method: "pause",
      restricted: [maintainRole$4]
    }), method({
      method: "unpause",
      restricted: [maintainRole$4]
    })]
  }, {
    name: "Configuration",
    description: undefined,
    methods: [method({
      method: "uri",
      parameters: [_int("tokenId")]
    }), method({
      method: "setUri",
      parameters: [string("newUri", "e.g http://url/uri")],
      restricted: [maintainRole$4]
    }), method({
      method: "setMetadataHashes",
      parameters: [arrayInt("ids"), arrayString("hashes")],
      restricted: [maintainRole$4]
    }), method({
      method: "setPaymentToken",
      parameters: [address("tokenAddress")],
      restricted: [maintainRole$4]
    })]
  }], Erc1155Doc.methodGroups, AccessControlDoc.methodGroups),
  formatError: function formatError(errorType) {
    switch (errorType) {
      case ErrorType.PreOrder_NoSupply:
        return "PreOrder has reach maxLimit for this item";

      case ErrorType.Token_NoSupply:
        return "Token is out of stock";

      case ErrorType.Token_InsufficientBalance:
        return "Your balance for this token is insufficient";

      case ErrorType.Wallet_InsufficientBalance:
        return "Your wallet balance is insufficient";

      case ErrorType.Wallet_InsufficientAllowance:
        return "Your wallet purchase allowance is insufficient";

      default:
        return errorType;
    }
  }
};

var maintainRole$3 = {
  name: "MAINTAINER_ROLE",
  role: keccak256(toUtf8Bytes("MAINTAINER_ROLE"))
};
var StoreDoc = {
  title: "Delysium DelysiumStore SDK",
  description: "Smart-contract SDK to manage terms of sales & sales & airdrop of DelysiumAssets",
  contractName: "store",
  roles: [],
  methodGroups: mergeMethods([{
    name: "Purchase",
    description: "Purchase NFTs",
    methods: [method({
      method: "hasSupply",
      parameters: [_int("modelId"), _int("quantity")]
    }), method({
      method: "preOrder",
      description: "Only available during pre-public sale",
      parameters: [_int("modelId"), _int("quantity")]
    }), method({
      method: "buy",
      parameters: [_int("modelId"), _int("quantity")]
    })]
  }, {
    name: "Operation",
    description: "manage store operation",
    methods: [method({
      method: "airDrop",
      parameters: [csv("receivers", "receiver,modelId,amount")],
      restricted: [maintainRole$3]
    }), method({
      method: "rawAirDrop",
      name: "bulk airDrop without metamask /!\\",
      parameters: [csv("receivers", "receiver,modelId,amount"), string("privateKey", "private key to sign the transaction"), object("gas", "maxPriorityFeePerGas,maxFeePerGas", false, "30,30"), object("alchemy", "apiKey,network,chainId,gasStation", true)],
      restricted: [maintainRole$3]
    })]
  }, {
    name: "Pre-sale",
    description: "manage whitelist and pre-sale",
    methods: [method({
      method: "setPreorderLimits",
      parameters: [csv("limits", "address,modelId,amount")],
      restricted: [maintainRole$3]
    }), method({
      method: "getPreOrderLimit",
      parameters: [address("account"), _int("tokenId")]
    }), method({
      method: "getPreOrderConsumed",
      parameters: [address("account"), _int("tokenId")]
    })]
  }, {
    name: "Accounting",
    description: undefined,
    methods: [method({
      method: "balance"
    }), method({
      method: "withdrawToken",
      description: "ratio usdc/userInput: 1USDC = 1000000",
      parameters: [address("to"), string("amount", "e.g 40000000")],
      restricted: [adminRole]
    })]
  }, {
    name: "Items",
    description: undefined,
    methods: [method({
      method: "getItem",
      parameters: [_int("id")]
    }), method({
      method: "getItems",
      parameters: [arrayInt("ids")]
    }), method({
      method: "getItemsMapped"
    }), method({
      method: "getExistIds"
    }), method({
      method: "setItems",
      parameters: [csv("items", "modelId,maxSupply,price,timePreorderStart,timePreorderEnd,timeSaleStart,timeSaleEnd,preorderDiscount")],
      restricted: [maintainRole$3]
    }), method({
      method: "removeItems",
      parameters: [arrayInt("ids")],
      restricted: [maintainRole$3]
    })]
  }, {
    name: "Management",
    description: undefined,
    methods: [method({
      method: "pause",
      description: "lock the purchase",
      restricted: [maintainRole$3]
    }), method({
      method: "unpause",
      restricted: [maintainRole$3]
    }), method({
      method: "setPaymentToken",
      parameters: [address("tokenAddress")],
      restricted: [maintainRole$3]
    })]
  }, {
    name: "Roles",
    description: "manage contract access",
    methods: [method({
      name: "Grant Maintainer role",
      method: "setAsMaintainer",
      parameters: [address("maintainer")]
    }), method({
      name: "Remove Maintainer role",
      method: "removeMaintainRole",
      parameters: [address("maintainer")]
    })]
  }], AccessControlDoc.methodGroups),
  formatError: undefined
};

var maintainRole$2 = {
  name: "MAINTAINER_ROLE",
  role: keccak256(toUtf8Bytes("MAINTAINER_ROLE"))
};
var minterRole = {
  name: "MINTER_ROLE",
  role: keccak256(toUtf8Bytes("MINTER_ROLE"))
};
var AssetsDoc = {
  title: "Delysium DelysiumAssets SDK",
  description: "Smart-contract SDK for unique tokens such as Guns",
  contractName: "assets",
  roles: [],
  methodGroups: mergeMethods([{
    name: "Tokens",
    description: undefined,
    methods: [method({
      method: "modelMinted",
      parameters: [_int("modelId")]
    }), method({
      method: "getModelId",
      parameters: [_int("tokenId")]
    }), method({
      method: "tokenData",
      parameters: [_int("tokenId")]
    })]
  }, {
    name: "Mint",
    description: undefined,
    methods: [method({
      method: "mint",
      parameters: [address("to"), _int("modelId"), _int("amount")],
      restricted: [minterRole]
    }), method({
      method: "mintBatch",
      parameters: [csv("receivers", "receiver,modelId,amount")],
      restricted: [minterRole]
    })]
  }, {
    name: "Transfer",
    description: "transfer tokens to other user(s)",
    methods: [method({
      method: "safeTransferFromBatch",
      parameters: [address("from"), address("to"), arrayInt("tokenIds")]
    }), method({
      method: "safeTransferFromToAddresses",
      parameters: [address("from"), csv("receivers", "receiver,tokenId")]
    })]
  }, {
    name: "Management",
    description: undefined,
    methods: [method({
      method: "pause",
      restricted: [maintainRole$2]
    }), method({
      method: "unpause",
      restricted: [maintainRole$2]
    })]
  }, {
    name: "Configuration",
    description: undefined,
    methods: [method({
      method: "baseURI"
    }), method({
      method: "tokenURI",
      parameters: [_int("tokenId")]
    }), method({
      method: "modelURI",
      parameters: [_int("modelId")]
    }), method({
      method: "setBaseURI",
      parameters: [string("newBaseURI", "e.g http://url/uri")],
      restricted: [maintainRole$2]
    }), method({
      method: "setModelURI",
      parameters: [_int("modelId"), string("modelURI", "e.g http://url/uri")],
      restricted: [maintainRole$2]
    }), method({
      method: "setModelURIBatch",
      parameters: [arrayInt("ids"), arrayString("uris", "e.g http://url/uri,http://url/uri2")],
      restricted: [maintainRole$2]
    }), method({
      method: "setTokenDataBatch",
      parameters: [arrayInt("tokenIds"), arrayString("data", "e.g data1,data2")],
      restricted: [maintainRole$2]
    })]
  }, {
    name: "Roles",
    description: "manage contract access",
    methods: [method({
      name: "Grant Maintainer role",
      method: "setAsMaintainer",
      parameters: [address("maintainer")]
    }), method({
      name: "Remove Maintainer role",
      method: "removeMaintainRole",
      parameters: [address("maintainer")]
    })]
  }], Erc721Doc.methodGroups, AccessControlDoc.methodGroups),
  formatError: undefined
};

var maintainRole$1 = {
  name: 'MAINTAINER_ROLE',
  role: keccak256(toUtf8Bytes('MAINTAINER_ROLE'))
};
var DMADoc = {
  title: 'Delysium DMA SDK',
  description: 'DMA SDK Doc, for purchasing and maintaining DMA',
  contractName: 'dma',
  roles: roles.apply(void 0, [maintainRole$1].concat(_toConsumableArray(AccessControlDoc.roles))),
  methodGroups: mergeMethods([{
    name: 'Purchase',
    description: 'Purchase DMA',
    methods: [method({
      method: 'buy',
      parameters: [string('accountUUID'), _int('amount'), string('invitationCode'), string('signature')]
    })]
  }, {
    name: 'Operation',
    description: 'manage airdrop of DMA to users',
    methods: [method({
      method: 'airDrop',
      description: 'arrays should be composed by values separated by ","',
      parameters: [arrayString('accountUUIDs', 'Array of account UUIDs'), arrayInt('amounts', 'Array of amounts (corresponding to UUIDs)')],
      restricted: [maintainRole$1]
    }), method({
      method: 'airDropByEmail',
      name: 'airDrop by emails',
      description: 'arrays should be composed by values separated by ","',
      parameters: [arrayString('accountEmails', 'Array of account Emails'), arrayInt('amounts', 'Array of amounts (corresponding to Emails)'), object('sso', 'domain,jwt', true)],
      restricted: [maintainRole$1]
    })]
  }, {
    name: 'Accounting',
    description: undefined,
    methods: [method({
      method: 'showBalance'
    }), method({
      name: 'showWithdrawReceiver',
      method: 'getWithdrawAddress'
    }), method({
      method: 'withdrawToken',
      description: 'ratio usdc/userInput: 1USDC = 1',
      parameters: [string('amount', 'e.g 1000')],
      restricted: [adminRole]
    })]
  }, {
    name: 'Manage',
    description: 'management of DMA Info',
    methods: [method({
      method: 'initialize',
      parameters: [string('initPaymentToken'), _int('maxSupply'), _int('price'), _int('priceIncreaseFrom'), _int('priceIncreaseInterval'), _int('priceIncreaseValue')],
      restricted: [maintainRole$1]
    }), method({
      method: 'setSaleInfo',
      parameters: [_int('maxSupply'), _int('price'), _int('priceIncreaseFrom'), _int('priceIncreaseInterval'), _int('priceIncreaseValue')],
      restricted: [maintainRole$1]
    })]
  }], AccessControlDoc.methodGroups),
  formatError: undefined
};

var maintainRole = {
  name: 'MAINTAINER_ROLE',
  role: keccak256(toUtf8Bytes('MAINTAINER_ROLE'))
};
var signerRole = {
  name: 'SIGNER_ROLE',
  role: keccak256(toUtf8Bytes('SIGNER_ROLE'))
};
var TokenWithdrawalDoc = {
  title: 'Delysium TokenWithdrawal SDK',
  description: 'TokenWithdrawal SDK Doc, for withdraw/deposit and maintaining DMA rewards',
  contractName: 'tokenWithdrawal',
  roles: roles.apply(void 0, [maintainRole, signerRole].concat(_toConsumableArray(AccessControlDoc.roles))),
  methodGroups: mergeMethods([{
    name: 'Withdraw/Deposit',
    description: 'Withdraw/Desposit Tokens',
    methods: [method({
      method: 'withdrawBySignature',
      parameters: [string('ERC20Address'), string('toAddress'), _int('amount'), string('accountUUID'), string('requestUUID'), string('accountUUID')]
    }), method({
      method: 'depositWithSignature',
      parameters: [string('tokenAddress'), _int('amount'), string('toAccountUUID'), string('requestUUID'), string('data'), string('signature')]
    })]
  }, {
    name: 'Accounting',
    description: undefined,
    methods: [method({
      method: 'getTokenBalance',
      parameters: [string('tokenAddress')]
    }), method({
      method: 'getWithdrawalRecipient'
    }), method({
      method: 'withdrawToken',
      description: 'use the proper decimals of the token',
      parameters: [string('tokenAddress'), string('amount', 'e.g usdc/usdt 6decimals')],
      restricted: [maintainRole]
    })]
  }, {
    name: 'Manage',
    description: 'management of TokenWithdrawal contract',
    methods: [method({
      method: 'pause',
      restricted: [maintainRole]
    }), method({
      method: 'unpause',
      restricted: [maintainRole]
    }), method({
      method: 'blockRequest',
      parameters: [string('requestUUID')],
      restricted: [maintainRole]
    }), method({
      method: 'setWithdrawalRecipient',
      parameters: [string('withdrawRecipient')],
      restricted: [adminRole]
    }), method({
      method: 'approveToken',
      parameters: [string('tokenAddress'), string('spender'), _int('amount')],
      restricted: [adminRole]
    })]
  }], AccessControlDoc.methodGroups),
  formatError: undefined
};

export { AccessControlDoc, AssetsDoc, AssetsSDK, CollectiblesDoc, CollectiblesSDK, ContractSDK, DMADoc, DMASDK, Erc1155Doc, Erc1155SDK, Erc20Doc, Erc20SDK, Erc721Doc, Erc721SDK, ErrorType, ParameterType, StoreDoc, StoreSDK, TeleportSDK, TokenWithdrawalDoc, TokenWithdrawalSDK, Uint };
